import Button from "@material-ui/core/Button";
import Drawer from "@material-ui/core/Drawer";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListSubheader from "@material-ui/core/ListSubheader";
import Paper from "@material-ui/core/Paper";
import Popover from "@material-ui/core/Popover";
import Tooltip from "@material-ui/core/Tooltip";
import { instance } from "Actions/AxiosInstance";
import { GetFeature } from "Actions/commonAction";
import biometric from "Assets/Icons/Biometric/biometric-outline-16px.svg";
import Clock from "Assets/Icons/Clock-time/clock-time-16px.svg";
import desktop from "Assets/Icons/Web/web-16px.svg";
import defaultEmp from "Assets/Images/defaultEmp.svg";
import crossIcon from "Assets/newicons/action/close-x/outline/close-x-outline-16px.svg";
import downloadIcon from "Assets/newicons/action/download/outline/download-outline-16px.svg";
import filterIcon from "Assets/newicons/action/filter/outline/filter-outline-16px-w.svg";
import uploadIcon from "Assets/newicons/action/upload/outline/upload-outline-16px.svg";
import attendanceIcon from "Assets/newicons/app/attendance/outline/attendance-outline-16px.svg";
import checklistoutlined from "Assets/newicons/app/checklist/outline/checklist-outline-16px.svg";
import holidayoutlined from "Assets/newicons/app/holiday/outline/holiday-outline-16px.svg";
import leavesIcon from "Assets/newicons/app/leaves/outline/leaves-outline-16px.svg";
import Performreviewoutlined from "Assets/newicons/app/okr/outilne/perform-outline-16px.svg";
import msgIcon from "Assets/newicons/app/request-center/outline/request-center-outline-16px.svg";
import downArrow from "Assets/newicons/arrow/chevron/down/outline/chevron-down-outline-16px.svg";
import leftArrow from "Assets/newicons/arrow/chevron/left/outline/chevron-left-outline-24px.svg";
import rightArrow from "Assets/newicons/arrow/chevron/right/outline/chevron-right-outline-24px.svg";
import taskIcon from "Assets/newicons/office/task/outline/task-outline-16px.svg";
import eventsIcon from "Assets/newicons/services/newspaper-magazine/outline/newspaper-magazine-outline-16px.svg";
import mediaIcon from "Assets/newicons/user-interface/attachment/outline/attachment-outline-16px.svg";
import calendarIcon from "Assets/newicons/user-interface/calendar/outline/calendar-outline-16px.svg";
import linkIcon from "Assets/newicons/user-interface/link-url/outline/link-url-outline-16px.svg";
import mobileicon from "Assets/newicons/user-interface/mobile/outline/mobile-outline-16px.svg";
import dependancyIcon from "Assets/newicons/user/dependent-user/outline/dependent-user-outline-16px.svg";
import birthdayEmoji from "Assets/Svg/birthday.svg";
import exitEmoji from "Assets/Svg/exit.svg";
import marriageAnniversaryEmoji from "Assets/Svg/marriage-anniversary.svg";
import newJoiningEmoji from "Assets/Svg/new-joining.svg";
import payrollglyph from "Assets/Svg/payroll-glyph-16-px.svg";
import workAnniversaryEmoji from "Assets/Svg/work-anniversary.svg";
import DynamicForm from "Component/DynamicForm";
import { checkboxinputconverter } from "Component/DynamicForm/Fields/CheckBox";
import { radioinputconverter } from "Component/DynamicForm/Fields/Radio";
import DrawerHeader from "Component/Headers/drawerHeader";
import IconLabel from "Component/Labels/IconLabel";
import LoaderComponent from "Component/Loader/index";
import ProfilePicture from "Component/Thumbnail/ProfilePicture";
import headersList from "Constants/headersList";
import get from "lodash/get";
import moment from "moment";
import { withSnackbar } from "notistack";
import React from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { bindActionCreators } from "redux";
import {
  getFormattedDateTime,
  getFormattedImageLink,
  getMonthName,
} from "Utils";
import "./index.scss";

// const localizer = Calendar.momentLocalizer(moment);
const localizer = momentLocalizer(moment);

const ToolBars = ({ min, max }) => {
  console.log("min, max: ", min, max);
  return class CustomToolbar1 extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        date: new Date(props.date),
      };
    }

    render() {
      const { label } = this.props;

      return (
        <div className="rbc-toolbar">
          <div
            className="cal-navigation display-flex width100"
            style={{ justifyContent: "center", alignItems: "center" }}
          >
            {/* {moment(this.state.date).format("MM") ==
              moment(max).format("MM") && ( */}
            <img
              src={leftArrow}
              className="margin-right-32"
              onClick={() => this.props.onNavigate("PREV")}
            ></img>
            {/* )} */}
            <p className="small-dark text-center" style={{ width: 262 }}>
              {label}
            </p>
            {/* {moment(this.state.date).format("MM") ==

              moment(min).format("MM") && ( */}
            <img
              src={rightArrow}
              className="margin-left-32"
              onClick={() => this.props.onNavigate("NEXT")}
            ></img>
            {/* )} */}
          </div>
        </div>
      );
    }
  };
};

const getCount = (count) => {
  if (count >= 3) {
    return count - 3;
  }
  return 0;
};

const getTime = (timeString) => {
  const H = +timeString.substr(0, 2);
  const h = H % 12 || 12;
  const ampm = H < 12 || H === 24 ? " am" : " pm";
  return h + timeString.substr(2, 3) + ampm;
};

const CustomEventContainer =
  ({
    openeventdetails,
    openshiftdetails,
    closedetails,
    view,
    isshiftplan,
    eventdetails,
    eventdetails_anchorEl,
    shiftdetails,
    shiftdetaildata,
    shiftdetaildata1,
    shiftdetails_anchorEl,
    selectedeventtype,
    defaultEmp,
    loadMonthEventItems,
    selectedDate,
    openDrawer,
    openDrawer1,
    OptionalDrawerOpen,
    MandatoryDrawerOpen,
    closeDrawer,
    closeDrawer1,
    weekviewdata,
    getData,
    downloadhtml,

    data1,
    data2,
    paysliploading,
    detailsloading,
    defaultDate,
    popupdata,
    todaysdate,
    tempList,
    templistdata,
  }) =>
  (props) =>
    (
      <CustomEvent
        events={props}
        openeventdetails={openeventdetails}
        openshiftdetails={openshiftdetails}
        closedetails={closedetails}
        eventdetails={eventdetails}
        shiftdetails={shiftdetails}
        shiftdetaildata={shiftdetaildata}
        shiftdetaildata1={shiftdetaildata1}
        eventdetails_anchorEl={eventdetails_anchorEl}
        selectedeventtype={selectedeventtype}
        view={view}
        isshiftplan={isshiftplan}
        defaultEmp={defaultEmp}
        loadMonthEventItems={loadMonthEventItems}
        selectedDate={selectedDate}
        openDrawer={openDrawer}
        openDrawer1={openDrawer1}
        OptionalDrawerOpen={OptionalDrawerOpen}
        MandatoryDrawerOpen={MandatoryDrawerOpen}
        closeDrawer={closeDrawer}
        closeDrawer1={closeDrawer1}
        weekviewdata={weekviewdata}
        popupdata={popupdata}
        getData={getData}
        downloadhtml={downloadhtml}
        data1={data1}
        data2={data2}
        paysliploading={paysliploading}
        defaultDate={defaultDate}
        todaysdate={todaysdate}
        tempList={tempList}
        templistdata={templistdata}
      />
    );

const CustomEvent = (props) => (
  <div>
    {props.view == "week" && (
      <div className="week-view-item">
        <ul
          className="padding-left-0"
          style={{ listStyleType: "none", width: "100%" }}
        >
          {props.templistdata ? (
            <li
              className="calendar-list-item-week"
              onClick={(e) =>
                props.openshiftdetails(
                  e,
                  "shift",
                  props.events.event.start,
                  props.events.event,
                )
              }

              // style={{backgroundColor}}
            >
              {props.events.event.isweekoff && (
                <div
                  style={{
                    width: "calc(100% - 6px)",
                    height: "calc(100vh - 238px)",
                    position: "absolute",
                    top: 2,
                    left: 3,
                    backgroundColor: "#FEF1D9",
                  }}
                ></div>
              )}
              <div
                className="margin-bottom-8"
                style={{ alignItems: "center", width: "100%" }}
              >
                <p
                  className="extra-small-dark margin-bottom-4"
                  style={{ color: "#0D0D0D", fontWeight: 400 }}
                >
                  Timing:
                </p>
                <Tooltip
                  title={`${getTime(
                    props.events.event.shifttime[0].shiftbegintime,
                  )} - ${getTime(
                    props.events.event.shifttime[0].shiftendtime,
                  )}`}
                  placement="top"
                >
                  <p
                    className="extra-small-dark margin-bottom-8 ellipsis width90"
                    style={{ color: "#0D0D0D", fontWeight: 400 }}
                  >
                    {`${getTime(
                      props.events.event.shifttime[0].shiftbegintime,
                    )} - ${getTime(
                      props.events.event.shifttime[0].shiftendtime,
                    )}`}
                  </p>
                </Tooltip>
                <p
                  className="extra-small-dark margin-bottom-4"
                  style={{ color: "#0D0D0D", fontWeight: 400 }}
                >
                  Name:
                </p>
                <Tooltip title={props.events.event.shiftname} placement="top">
                  <p
                    className="extra-small-dark ellipsis width90"
                    style={{ color: "#0D0D0D", fontWeight: 400 }}
                  >
                    {props.events.event.shiftname}
                  </p>
                </Tooltip>
              </div>
            </li>
          ) : (
            <>
              {props.events.event.onLeave &&
                props.events.event.onLeave.general &&
                props.events.event.onLeave.general.length > 0 && (
                  <li
                    className="calendar-list-item-week"
                    onClick={(e) =>
                      props.openeventdetails(
                        e,
                        "leave",
                        props.events.event.start,
                        null,
                        null,
                        [1],
                        [1],
                      )
                    }
                  >
                    <div
                      className="display-flex margin-bottom-8"
                      style={{ alignItems: "center" }}
                    >
                      <span
                        className="extra-small-dark t-bold"
                        style={{ color: "#0D0D0D", fontWeight: 400 }}
                      >
                        Leaves
                      </span>
                      <span className="rounded-span">
                        {props.events.event.onLeave.general.length}
                      </span>
                    </div>
                    <div
                      style={{
                        borderLeft: "2px solid #2D75FF",
                        padding: "0px 8px",
                      }}
                    >
                      <div
                        className="display-flex"
                        style={{ alignItems: "center" }}
                      >
                        <div style={{ height: 20, display: "flex" }}>
                          {props.events.event.onLeave.general.length > 0 &&
                            props.events.event.onLeave.general.map(
                              (emp, index) =>
                                index < 3 && (
                                  <div
                                    key="key"
                                    style={{
                                      width: 20,
                                      height: 20,
                                      marginLeft: 0,
                                    }}
                                  >
                                    <Tooltip
                                      title={emp.fullname}
                                      placement="top"
                                    >
                                      <div>
                                        {emp.imagepath == null ? (
                                          <img
                                            src={defaultEmp}
                                            height="20"
                                            className="team-avatar"
                                          />
                                        ) : (
                                          <img
                                            src={getFormattedImageLink(
                                              emp.imagepath,
                                            )}
                                            height="20"
                                            className="team-avatar"
                                          />
                                        )}
                                      </div>
                                    </Tooltip>
                                  </div>
                                ),
                            )}
                        </div>
                        {getCount(props.events.event.onLeave.general.length) >
                        0 ? (
                          <span className="small-dark-secondary margin-left-4">
                            +{" "}
                            {getCount(
                              props.events.event.onLeave.general.length,
                            )}{" "}
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </li>
                )}

              {((props.events.event.onHoliday &&
                props.events.event.onHoliday.optional &&
                props.events.event.onHoliday.optional.length > 0) ||
                (props.events.event.onHoliday &&
                  props.events.event.onHoliday.mandatory &&
                  props.events.event.onHoliday.mandatory.length > 0)) && (
                <li
                  className="calendar-list-item-week"
                  onClick={(e) =>
                    props.openeventdetails(
                      e,
                      "holiday",
                      props.events.event.start,
                      props.events.event.onHoliday.mandatory,
                      props.events.event.onHoliday.optional,
                      [2],
                      [2, 3],
                    )
                  }
                >
                  <div
                    className="display-flex margin-bottom-8"
                    style={{ alignItems: "center" }}
                  >
                    <span
                      className="extra-small-dark t-bold"
                      style={{ color: "#0D0D0D", fontWeight: 400 }}
                    >
                      Holiday
                    </span>
                    <span className="rounded-span">
                      {props.events.event.onHoliday &&
                        props.events.event.onHoliday.optional &&
                        props.events.event.onHoliday.mandatory &&
                        props.events.event.onHoliday.optional.length +
                          props.events.event.onHoliday.mandatory.length}
                    </span>
                  </div>
                  <div
                    style={{
                      borderLeft: "2px solid #FF45E4",
                      padding: "0px 8px",
                    }}
                  >
                    {props.events.event.onHoliday &&
                      props.events.event.onHoliday.optional &&
                      props.events.event.onHoliday.optional.length > 0 && (
                        <div>
                          <p className="extra-small-dark margin-bottom-4">
                            Optional holiday
                          </p>
                          <div
                            className="display-flex"
                            style={{ alignItems: "center" }}
                          >
                            <div style={{ height: 20, display: "flex" }}>
                              {props.events.event.onHoliday.optional.length >
                                0 &&
                                props.events.event.onHoliday.optional.map(
                                  (emp, index) =>
                                    index < 3 && (
                                      <div
                                        key="key"
                                        style={{
                                          width: 20,
                                          height: 20,
                                          marginLeft: 0,
                                        }}
                                      >
                                        <Tooltip
                                          title={emp.fullname}
                                          placement="top"
                                        >
                                          <div>
                                            {emp.imagepath == null ? (
                                              <img
                                                src={defaultEmp}
                                                height="20"
                                                className="team-avatar"
                                              />
                                            ) : (
                                              <img
                                                src={getFormattedImageLink(
                                                  emp.imagepath,
                                                )}
                                                height="20"
                                                className="team-avatar"
                                              />
                                            )}
                                          </div>
                                        </Tooltip>
                                      </div>
                                    ),
                                )}
                            </div>
                            {getCount(
                              props.events.event.onHoliday.optional.length,
                            ) > 0 ? (
                              <span className="small-dark-secondary margin-left-4">
                                + backgroundColor
                                {getCount(
                                  props.events.event.onHoliday.optional.length,
                                )}
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      )}
                    {props.events.event.onHoliday &&
                      props.events.event.onHoliday.mandatory &&
                      props.events.event.onHoliday.mandatory.length > 0 && (
                        <div className="margin-top-16">
                          <p className="extra-small-dark margin-bottom-4">
                            Mandatory holiday
                          </p>
                          <div
                            className="display-flex"
                            style={{ alignItems: "center" }}
                          >
                            <div style={{ height: 20, display: "flex" }}>
                              {props.events.event.onHoliday.mandatory.length >
                                0 &&
                                props.events.event.onHoliday.mandatory.map(
                                  (emp, index) =>
                                    index < 3 && (
                                      <div
                                        key="key"
                                        style={{
                                          width: 20,
                                          height: 20,
                                          marginLeft: 0,
                                        }}
                                      >
                                        <Tooltip
                                          title={emp.fullname}
                                          placement="top"
                                        >
                                          <div>
                                            {emp.imagepath == null ? (
                                              <img
                                                src={defaultEmp}
                                                height="20"
                                                className="team-avatar"
                                              />
                                            ) : (
                                              <img
                                                src={getFormattedImageLink(
                                                  emp.imagepath,
                                                )}
                                                height="20"
                                                className="team-avatar"
                                              />
                                            )}
                                          </div>
                                        </Tooltip>
                                      </div>
                                    ),
                                )}
                            </div>
                            {getCount(
                              props.events.event.onHoliday.mandatory.length,
                            ) > 0 ? (
                              <span className="small-dark-secondary margin-left-4">
                                +{" "}
                                {getCount(
                                  props.events.event.onHoliday.mandatory.length,
                                )}
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      )}
                  </div>
                </li>
              )}

              {props.events.event.event != null &&
                ((props.events.event.event.anniversary &&
                  props.events.event.event.anniversary.length > 0) ||
                  (props.events.event.event.birthday &&
                    props.events.event.event.birthday.length > 0) ||
                  (props.events.event.event.exit &&
                    props.events.event.event.exit.length > 0) ||
                  (props.events.event.event.newjoin &&
                    props.events.event.event.newjoin.length > 0) ||
                  (props.events.event.event.workanniversary &&
                    props.events.event.event.workanniversary.length > 0)) && (
                  <li
                    className="calendar-list-item-week"
                    onClick={(e) =>
                      props.openeventdetails(
                        e,
                        "events",
                        props.events.event.start,
                        null,
                        null,
                        [3],
                        [4, 5, 6, 7, 8],
                      )
                    }
                  >
                    <div
                      className="display-flex margin-bottom-8"
                      style={{ alignItems: "center" }}
                    >
                      <span
                        className="extra-small-dark t-bold"
                        style={{ color: "#0D0D0D", fontWeight: 400 }}
                      >
                        Events
                      </span>
                      <span className="rounded-span">
                        {props.events.event.event.anniversary.length +
                          props.events.event.event.birthday.length +
                          props.events.event.event.workanniversary.length +
                          props.events.event.event.newjoin.length +
                          props.events.event.event.exit.length}
                      </span>
                    </div>
                    <div
                      style={{
                        borderLeft: "2px solid #FF653B",
                        padding: "0px 8px",
                      }}
                    >
                      {props.events.event.event &&
                        props.events.event.event.birthday &&
                        props.events.event.event.birthday.length > 0 &&
                        props.events.event.event.birthday.map((x) => (
                          <div
                            className="display-flex margin-bottom-8"
                            style={{ alignItems: "center" }}
                          >
                            <Tooltip title={x.fullname} position="top">
                              <img
                                src={
                                  x.imagepath
                                    ? getFormattedImageLink(x.imagepath)
                                    : defaultEmp
                                }
                                height="20"
                                className="team-avatar"
                              />
                            </Tooltip>
                            <Tooltip title="Birthday" position="top">
                              <span
                                className="small-dark margin-left-8 ellipsis width70"
                                style={{ fontWeight: 400 }}
                              >
                                Birthday
                              </span>
                            </Tooltip>
                          </div>
                        ))}
                      {props.events.event.event &&
                        props.events.event.event.workanniversary &&
                        props.events.event.event.workanniversary.length > 0 &&
                        props.events.event.event.workanniversary.map((x) => (
                          <div
                            className="display-flex margin-bottom-8"
                            style={{ alignItems: "center" }}
                          >
                            <Tooltip title={x.fullname} position="top">
                              <img
                                src={
                                  x.imagepath
                                    ? getFormattedImageLink(x.imagepath)
                                    : defaultEmp
                                }
                                height="20"
                                className="team-avatar"
                              />
                            </Tooltip>
                            <Tooltip title=" Work anniversary" position="top">
                              <span
                                className="small-dark margin-left-8 ellipsis width70"
                                style={{ fontWeight: 400 }}
                              >
                                Work anniversary
                              </span>
                            </Tooltip>
                          </div>
                        ))}

                      {props.events.event.event &&
                        props.events.event.event.anniversary &&
                        props.events.event.event.anniversary.length > 0 &&
                        props.events.event.event.anniversary.map((x) => (
                          <div
                            className="display-flex margin-bottom-8"
                            style={{ alignItems: "center" }}
                          >
                            <Tooltip title={x.fullname} position="top">
                              <img
                                src={
                                  x.imagepath
                                    ? getFormattedImageLink(x.imagepath)
                                    : defaultEmp
                                }
                                height="20"
                                className="team-avatar"
                              />
                            </Tooltip>

                            <Tooltip
                              title="Marriage anniversary"
                              position="top"
                            >
                              <span
                                className="small-dark margin-left-8 ellipsis width70"
                                style={{ fontWeight: 400 }}
                              >
                                Marriage anniversary
                              </span>
                            </Tooltip>
                          </div>
                        ))}

                      {props.events.event.event &&
                        props.events.event.event.newjoin &&
                        props.events.event.event.newjoin.length > 0 &&
                        props.events.event.event.newjoin.map((x) => (
                          <div
                            className="display-flex margin-bottom-8"
                            style={{ alignItems: "center" }}
                          >
                            <Tooltip title={x.fullname} position="top">
                              <img
                                src={
                                  x.imagepath
                                    ? getFormattedImageLink(x.imagepath)
                                    : defaultEmp
                                }
                                height="20"
                                className="team-avatar"
                              />
                            </Tooltip>
                            <Tooltip title="New joining" position="top">
                              <span
                                className="small-dark margin-left-8 ellipsis width70"
                                style={{ fontWeight: 400 }}
                              >
                                New joining
                              </span>
                            </Tooltip>
                          </div>
                        ))}

                      {props.events.event.event &&
                        props.events.event.event.exit &&
                        props.events.event.event.exit.length > 0 &&
                        props.events.event.event.exit.map((x) => (
                          <div
                            className="display-flex margin-bottom-8"
                            style={{ alignItems: "center" }}
                          >
                            <Tooltip title={x.fullname} position="top">
                              <img
                                src={
                                  x.imagepath
                                    ? getFormattedImageLink(x.imagepath)
                                    : defaultEmp
                                }
                                height="20"
                                className="team-avatar"
                              />
                            </Tooltip>
                            <Tooltip title="Last day (exit)" position="top">
                              <span
                                className="small-dark margin-left-8 ellipsis width70"
                                style={{ fontWeight: 400 }}
                              >
                                Last day (exit)
                              </span>
                            </Tooltip>
                          </div>
                        ))}

                      {/* <span
                    className="small-dark-secondary"
                    style={{ color: "#6C6C6C", fontSize: 11 }}
                  >
                    2 more..
                  </span> */}
                    </div>
                  </li>
                )}

              {props.events.event.shiftchange &&
                props.events.event.shiftchange.length > 0 && (
                  <li
                    className="calendar-list-item-week"
                    onClick={(e) =>
                      props.openeventdetails(
                        e,
                        "shiftchange",
                        props.events.event.start,
                        null,
                        null,
                        [4],
                        [],
                      )
                    }
                  >
                    <div
                      className="display-flex margin-bottom-8"
                      style={{ alignItems: "center" }}
                    >
                      <span
                        className="extra-small-dark t-bold"
                        style={{ color: "#0D0D0D", fontWeight: 400 }}
                      >
                        Shift change
                      </span>
                    </div>
                    <div
                      style={{
                        borderLeft: "2px solid #FAC710",
                        padding: "0px 8px",
                      }}
                    >
                      {props.events.event.shiftchange[0].shiftiming &&
                        props.events.event.shiftchange[0].shiftiming.map(
                          (shift) => (
                            <div className="margin-bottom-16">
                              <div
                                className="display-flex margin-bottom-4"
                                style={{ alignItems: "center" }}
                              >
                                <span
                                  className="extra-small-dark-secondary"
                                  style={{
                                    color: "#6C6C6C",
                                    fontSize: 11,
                                  }}
                                >
                                  Start: &nbsp;
                                </span>
                                <span
                                  className="small-dark-secondary"
                                  style={{ color: "#0D0D0D", fontWeight: 400 }}
                                >
                                  {getTime(shift.shiftbegintime)}
                                </span>
                              </div>
                              <div
                                className="display-flex"
                                style={{ alignItems: "center" }}
                              >
                                <span
                                  className="extra-small-dark-secondary"
                                  style={{
                                    color: "#6C6C6C",
                                    fontSize: 11,
                                  }}
                                >
                                  End: &nbsp;
                                </span>
                                <span
                                  className="small-dark-secondary"
                                  style={{ color: "#0D0D0D", fontWeight: 400 }}
                                >
                                  {getTime(shift.shiftendtime)}
                                </span>
                              </div>
                            </div>
                          ),
                        )}
                    </div>
                  </li>
                )}

              {props.events.event.checklist &&
                props.events.event.checklist.length > 0 && (
                  <li
                    className="calendar-list-item-week"
                    onClick={(e) =>
                      props.openeventdetails(
                        e,
                        "checklistitem",
                        props.events.event.start,
                        null,
                        null,
                        [5],
                        [],
                      )
                    }
                  >
                    <div
                      className="display-flex margin-bottom-8"
                      style={{ alignItems: "center" }}
                    >
                      <span
                        className="extra-small-dark t-bold"
                        style={{ color: "#0D0D0D", fontWeight: 400 }}
                      >
                        Checklist item
                      </span>
                      <span className="rounded-span">
                        {props.events.event.checklist &&
                          props.events.event.checklist.length > 0 &&
                          props.events.event.checklist.length}
                      </span>
                    </div>
                    <div
                      style={{
                        borderLeft: "2px solid #12CDD4",
                        padding: "0px 8px",
                      }}
                    >
                      {props.events.event.checklist.length > 0 &&
                        props.events.event.checklist.map((item) => (
                          <div
                            className="display-flex margin-bottom-8"
                            style={{ alignItems: "center" }}
                          >
                            <Tooltip title={item.checklistname}>
                              <span
                                className="small-dark ellipsis width70"
                                style={{ fontWeight: 400 }}
                              >
                                {item.checklistname}
                              </span>
                            </Tooltip>
                          </div>
                        ))}

                      {/* <span
                  className="extra-small-dark-secondary"
                  style={{ color: "#6C6C6C", fontSize: 11, fontWeight: 400 }}
                >
                  2 more..
                </span> */}
                    </div>
                  </li>
                )}

              {props.events.event.reviewform &&
                props.events.event.reviewform.open &&
                props.events.event.reviewform.open.length > 0 && (
                  <li
                    className="calendar-list-item-week"
                    onClick={(e) =>
                      props.openeventdetails(
                        e,
                        "reviewopen",
                        props.events.event.start,
                        null,
                        null,
                        [6],
                        [9],
                      )
                    }
                  >
                    <div
                      className="display-flex margin-bottom-8"
                      style={{ alignItems: "center" }}
                    >
                      <span
                        className="extra-small-dark t-bold"
                        style={{ color: "#0D0D0D", fontWeight: 400 }}
                      >
                        Review open
                      </span>
                      <span className="rounded-span">
                        {props.events.event.reviewform.open &&
                          props.events.event.reviewform.open.length > 0 &&
                          props.events.event.reviewform.open.length}
                      </span>
                    </div>
                    {props.events.event.reviewform.open &&
                      props.events.event.reviewform.open.length > 0 &&
                      props.events.event.reviewform.open.map((x) => (
                        <div
                          style={{
                            borderLeft: "2px solid #8FD14F",
                            padding: "0px 8px",
                          }}
                        >
                          <p
                            className="extra-small-dark-secondary margin-bottom-8"
                            style={{
                              color: "#6C6C6C",
                              fontSize: 11,
                              fontWeight: 700,
                            }}
                          >
                            {x.period}
                          </p>

                          <p className="small-dark ellipsis width70 margin-bottom-8">
                            {x.formtitle}
                          </p>

                          {/* <p
                  className="small-dark-secondary"
                  style={{ color: "#6C6C6C", fontSize: 11 }}
                >
                  2 more..
                </p> */}
                        </div>
                      ))}
                  </li>
                )}

              {props.events.event.reviewform &&
                props.events.event.reviewform.close &&
                props.events.event.reviewform.close.length > 0 && (
                  <li
                    className="calendar-list-item-week"
                    onClick={(e) =>
                      props.openeventdetails(
                        e,
                        "reviewclose",
                        props.events.event.start,
                        null,
                        null,
                        [6],
                        [10],
                      )
                    }
                  >
                    <div
                      className="display-flex margin-bottom-8"
                      style={{ alignItems: "center" }}
                    >
                      <span
                        className="extra-small-dark t-bold"
                        style={{ color: "#0D0D0D", fontWeight: 400 }}
                      >
                        Review close
                      </span>
                      <span className="rounded-span">
                        {props.events.event.reviewform.close &&
                          props.events.event.reviewform.close.length > 0 &&
                          props.events.event.reviewform.close.length}
                      </span>
                    </div>
                    {props.events.event.reviewform.close &&
                      props.events.event.reviewform.close.map((x) => (
                        <div
                          style={{
                            borderLeft: "2px solid #8FD14F",
                            padding: "0px 8px",
                          }}
                        >
                          <p
                            className="extra-small-dark-secondary margin-bottom-8"
                            style={{
                              color: "#6C6C6C",
                              fontSize: 11,
                              fontWeight: 700,
                            }}
                          >
                            {x.period}
                          </p>

                          <p className="small-dark ellipsis width70 margin-bottom-8">
                            {x.formtitle}
                          </p>

                          {/* <p
                  className="small-dark-secondary"
                  style={{ color: "#6C6C6C", fontSize: 11 }}
                >
                  2 more..
                </p> */}
                        </div>
                      ))}
                  </li>
                )}

              {props.events.event.paryoll &&
                props.events.event.paryoll.length > 0 && (
                  <li
                    className="calendar-list-item-week"
                    onClick={(e) =>
                      props.openeventdetails(
                        e,
                        "payrollrun",
                        props.events.event.start,
                        null,
                        null,
                        [7],
                        [],
                      )
                    }
                  >
                    <p
                      className="extra-small-dark t-bold margin-bottom-8"
                      style={{
                        color: "#0D0D0D",
                        fontWeight: 400,
                      }}
                    >
                      Payslip generated
                    </p>

                    <div
                      style={{
                        borderLeft: "2px solid #414BB2",
                        padding: "0px 8px",
                      }}
                    >
                      <p
                        className="extra-small-dark-secondary"
                        style={{
                          color: "#6C6C6C",
                          fontSize: 11,
                          fontWeight: 700,
                        }}
                      >
                        Download salary slip
                      </p>
                    </div>
                  </li>
                )}
            </>
          )}
        </ul>
      </div>
    )}

    {props.view == "month" && (
      <div
        className="month-view-item position-rel"
        // style={{
        //   backgroundColor: props.events.event.isweekoff ? "#FEF1D9" : "",
        // }}
      >
        {moment(props.events.event.start).format("YYYY-MM-DD") ==
          moment(props.todaysdate).format("YYYY-MM-DD") && (
          <p
            className="extra-small-blue t-bold"
            style={{ position: "absolute", right: 8, top: -17 }}
          >
            Today
          </p>
        )}
        <ul
          className="padding-left-0 month-view-item-list super-thin-scroll"
          style={{
            listStyleType: "none",
            width: "100%",
            marginTop: 24,
            height: 108,
            overflowY: "auto",
          }}
        >
          {props.templistdata ? (
            <li
              className="calendar-list-item"
              onClick={(e) =>
                props.openshiftdetails(
                  e,
                  "shift",
                  props.events.event.start,
                  props.events.event,
                )
              }
              // style={{ backgroundColor: props.events.event.isweekoff ? "#FEF1D9" : "" }}
            >
              {props.events.event.isweekoff && (
                <div
                  style={{
                    width: "100%",
                    height: 140,
                    position: "absolute",
                    top: -24,
                    left: 0,
                    backgroundColor: "#FEF1D9",
                  }}
                ></div>
              )}
              <div
                className="margin-bottom-8"
                style={{ alignItems: "center", width: "100%" }}
              >
                <p
                  className="extra-small-dark margin-bottom-4"
                  style={{ color: "#0D0D0D", fontWeight: 400 }}
                >
                  Timing:
                </p>
                <Tooltip
                  title={`${getTime(
                    props.events.event.shifttime[0].shiftbegintime,
                  )} - ${getTime(
                    props.events.event.shifttime[0].shiftendtime,
                  )}`}
                  placement="top"
                >
                  <p
                    className="extra-small-dark margin-bottom-8 ellipsis width90"
                    style={{ color: "#0D0D0D", fontWeight: 400 }}
                  >
                    {`${getTime(
                      props.events.event.shifttime[0].shiftbegintime,
                    )} - ${getTime(
                      props.events.event.shifttime[0].shiftendtime,
                    )}`}
                  </p>
                </Tooltip>
                <p
                  className="extra-small-dark margin-bottom-4"
                  style={{ color: "#0D0D0D", fontWeight: 400 }}
                >
                  Name:
                </p>
                <Tooltip title={props.events.event.shiftname} placement="top">
                  <p
                    className="extra-small-dark ellipsis width90"
                    style={{ color: "#0D0D0D", fontWeight: 400 }}
                  >
                    {props.events.event.shiftname}
                  </p>
                </Tooltip>
              </div>
            </li>
          ) : (
            <>
              {props.events.event.onLeave &&
                props.events.event.onLeave.count > 0 && (
                  <li
                    className="calendar-list-item"
                    onClick={(e) =>
                      props.openeventdetails(
                        e,
                        "leave",
                        props.events.event.start,
                        null,
                        null,
                        [1],
                        [1],
                      )
                    }
                  >
                    <span
                      className="dot"
                      style={{ backgroundColor: "#2D75FF" }}
                    ></span>
                    <span
                      className="extra-small-dark"
                      style={{ color: "#0D0D0D", fontWeight: 400 }}
                    >
                      Leaves
                    </span>
                    <span className="rounded-span">
                      {props.events.event.onLeave.count}
                    </span>
                  </li>
                )}

              {props.events.event.onHoliday &&
                props.events.event.onHoliday.count > 0 && (
                  <li
                    className="calendar-list-item"
                    onClick={(e) =>
                      props.openeventdetails(
                        e,
                        "holiday",
                        props.events.event.start,
                        props.events.event.onHoliday.mandatory,
                        props.events.event.onHoliday.optional,
                        [2],
                        [2, 3],
                      )
                    }
                  >
                    <span
                      className="dot"
                      style={{ backgroundColor: "#FF45E4" }}
                    ></span>
                    <span
                      className="extra-small-dark"
                      style={{ color: "#0D0D0D", fontWeight: 400 }}
                    >
                      Holidays
                    </span>
                    <span className="rounded-span">
                      {props.events.event.onHoliday &&
                        props.events.event.onHoliday.count}
                    </span>
                  </li>
                )}

              {props.events.event.event && props.events.event.event.count > 0 && (
                <li
                  className="calendar-list-item position-rel"
                  onClick={(e) =>
                    props.openeventdetails(
                      e,
                      "events",
                      props.events.event.start,
                      null,
                      null,
                      [3],
                      [4, 5, 6, 7, 8],
                    )
                  }
                >
                  <span
                    className="dot"
                    style={{ backgroundColor: "#FF653B" }}
                  ></span>
                  <span
                    className="extra-small-dark"
                    style={{ color: "#0D0D0D", fontWeight: 400 }}
                  >
                    Events
                  </span>
                  {props.events.event.event &&
                    props.events.event.event.count &&
                    props.events.event.event.count != 0 && (
                      <span className="rounded-span">
                        {props.events.event.event.count}
                      </span>
                    )}
                </li>
              )}

              {props.events.event.shiftchange &&
                props.events.event.shiftchange.length > 0 && (
                  <li
                    className="calendar-list-item"
                    onClick={(e) =>
                      props.openeventdetails(
                        e,
                        "shiftchange",
                        props.events.event.start,
                        null,
                        null,
                        [4],
                        [],
                      )
                    }
                  >
                    <span
                      className="dot"
                      style={{ backgroundColor: "#FAC710" }}
                    ></span>
                    <span
                      className="extra-small-dark"
                      style={{ color: "#0D0D0D", fontWeight: 400 }}
                    >
                      Shift change
                    </span>
                  </li>
                )}

              {props.events.event.checklist &&
                props.events.event.checklist.length > 0 && (
                  <li
                    className="calendar-list-item"
                    onClick={(e) =>
                      props.openeventdetails(
                        e,
                        "checklistitem",
                        props.events.event.start,
                        null,
                        null,
                        [5],
                        [],
                      )
                    }
                  >
                    <span
                      className="dot"
                      style={{ backgroundColor: "#12CDD4" }}
                    ></span>
                    <span
                      className="extra-small-dark"
                      style={{ color: "#0D0D0D", fontWeight: 400 }}
                    >
                      Checklist item
                    </span>
                    <span className="rounded-span">
                      {props.events.event.checklist.length}
                    </span>
                  </li>
                )}

              {props.events.event.reviewform &&
                props.events.event.reviewform.open.length > 0 && (
                  <li
                    className="calendar-list-item"
                    onClick={(e) =>
                      props.openeventdetails(
                        e,
                        "reviewopen",
                        props.events.event.start,
                        null,
                        null,
                        [6],
                        [9],
                      )
                    }
                  >
                    <span
                      className="dot"
                      style={{ backgroundColor: "#8FD14F" }}
                    ></span>
                    <span
                      className="extra-small-dark"
                      style={{ color: "#0D0D0D", fontWeight: 400 }}
                    >
                      Review start
                    </span>
                    <span className="rounded-span">
                      {props.events.event.reviewform.open.length}
                    </span>
                  </li>
                )}

              {props.events.event.reviewform &&
                props.events.event.reviewform.close.length > 0 && (
                  <li
                    className="calendar-list-item"
                    onClick={(e) =>
                      props.openeventdetails(
                        e,
                        "reviewclose",
                        props.events.event.start,
                        null,
                        null,
                        [6],
                        [10],
                      )
                    }
                  >
                    <span
                      className="dot"
                      style={{ backgroundColor: "#8FD14F" }}
                    ></span>
                    <span
                      className="extra-small-dark"
                      style={{ color: "#0D0D0D", fontWeight: 400 }}
                    >
                      Review end
                    </span>
                    <span className="rounded-span">
                      {props.events.event.reviewform.close.length}
                    </span>
                  </li>
                )}

              {props.events.event.paryoll.length > 0 && (
                <li
                  className="calendar-list-item"
                  onClick={(e) =>
                    props.openeventdetails(
                      e,
                      "payrollrun",
                      props.events.event.start,
                      null,
                      null,
                      [7],
                      [],
                    )
                  }
                >
                  <span
                    className="dot"
                    style={{ backgroundColor: "#414BB2" }}
                  ></span>
                  <span
                    className="extra-small-dark"
                    style={{ color: "#0D0D0D", fontWeight: 400 }}
                  >
                    Payslip generated
                  </span>
                </li>
              )}
            </>
          )}
        </ul>
        {/* <div
          className="calendar-list-item"
          style={{ border: "none" }}
          onClick={props.loadMonthEventItems}
        >
          <span
            className="extra-small-blue t-bold margin-left-16"
            style={{ fontWeight: 400 }}
          >
            4 more items...
          </span>
        </div> */}
      </div>
    )}

    {props.detailsloading ? (
      <div>
        <LoaderComponent />
      </div>
    ) : (
      <div>
        {props.selectedDate == props.events.event.start && (
          <Popover
            open={props.eventdetails}
            anchorEl={props.eventdetails_anchorEl}
            anchorOrigin={{
              vertical: "center",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "center",
              horizontal: "center",
            }}
            onClose={props.closedetails}
            style={{ background: "rgba(0,0,0,0.5)" }}
            classes={{
              paper: "calendar-paper",
            }}
          >
            <Paper
              className="thin-scroll"
              style={{
                width: 368,
                padding: 16,
                maxHeight: 400,
                overflowY: "auto",
              }}
            >
              <div
                className="display-flex margin-bottom-32"
                style={{ justifyContent: "space-between" }}
              >
                <NavLink
                  to={props.selectedeventtype == "holiday" ? "/holiday" : ""}
                >
                  <div>
                    <IconLabel
                      label={
                        props.selectedeventtype == "leave"
                          ? "Leaves"
                          : props.selectedeventtype == "holiday"
                          ? "Holiday"
                          : props.selectedeventtype == "events"
                          ? "Events"
                          : props.selectedeventtype == "checklistitem"
                          ? "Cheklist item"
                          : props.selectedeventtype == "shiftchange"
                          ? "Shift change"
                          : props.selectedeventtype == "reviewopen"
                          ? "Review open"
                          : props.selectedeventtype == "reviewclose"
                          ? "Review close"
                          : "Payslip generated"
                      }
                      img={
                        props.selectedeventtype == "leave"
                          ? leavesIcon
                          : props.selectedeventtype == "holiday"
                          ? holidayoutlined
                          : props.selectedeventtype == "events"
                          ? eventsIcon
                          : props.selectedeventtype == "checklistitem"
                          ? checklistoutlined
                          : props.selectedeventtype == "shiftchange"
                          ? attendanceIcon
                          : props.selectedeventtype == "reviewopen"
                          ? Performreviewoutlined
                          : props.selectedeventtype == "reviewclose"
                          ? Performreviewoutlined
                          : payrollglyph
                      }
                      labelClassNames="small-dark t-bold"
                      iconHeight="16"
                      className="margin-right-16"
                    />
                  </div>
                </NavLink>
                <div className="display-flex">
                  <p className="small-dark-secondary margin-right-16">
                    {props.events.event.date}
                  </p>
                  <img
                    src={crossIcon}
                    onClick={props.closedetails}
                    className="cursor-pointer"
                  ></img>
                </div>
              </div>

              {props.selectedeventtype == "holiday" && (
                <div>
                  {props.data1 && props.data1.length > 0 && (
                    <div
                      className="display-flex margin-bottom-16"
                      style={{ justifyContent: "space-between" }}
                    >
                      <div>
                        <p className="small-dark" style={{ color: "#0D0D0D" }}>
                          {props.data1[0].holidayname}
                        </p>

                        <span
                          className="extra-small-dark-secondary"
                          onClick={() => props.openDrawer1()}
                        >
                          Mandatory holiday -{" "}
                          <span style={{ color: "#1e8ced", cursor: "pointer" }}>
                            {" "}
                            {props.data1.length} employees
                          </span>
                        </span>
                      </div>
                    </div>
                  )}

                  {props.data2 && props.data2.length > 0 && (
                    <div
                      className="display-flex margin-bottom-16"
                      style={{ justifyContent: "space-between" }}
                    >
                      <div>
                        <p className="small-dark" style={{ color: "#0D0D0D" }}>
                          {props.data2[0].holidayname}
                        </p>

                        <span
                          className="extra-small-dark-secondary"
                          onClick={() => props.openDrawer()}
                        >
                          Optional holiday -{" "}
                          <span style={{ color: "#1e8ced", cursor: "pointer" }}>
                            {" "}
                            {props.data2.length} employees
                          </span>
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              )}

              {props.selectedeventtype == "leave" && (
                <div>
                  {props.popupdata[0].onLeave &&
                    props.popupdata[0].onLeave.general &&
                    props.popupdata[0].onLeave.general.length > 0 &&
                    props.popupdata[0].onLeave.general.map((x2) => (
                      <div
                        className="display-flex margin-bottom-16"
                        style={{ justifyContent: "space-between" }}
                      >
                        <div
                          className="display-flex"
                          style={{
                            alignItems: "center",
                            width: "60%",
                          }}
                        >
                          <img
                            src={
                              x2.imagepath
                                ? getFormattedImageLink(x2.imagepath)
                                : defaultEmp
                            }
                            height="32"
                            className="margin-right-8"
                            style={{ borderRadius: 20 }}
                          ></img>
                          <div>
                            <Tooltip title={x2.fullname} placement="top-start">
                              <p className="small-dark-secondary ellipsis width100">
                                {x2.fullname}
                              </p>
                            </Tooltip>

                            <span className="extra-small-dark-secondary">
                              {moment(x2.fromdate).format("Do MMM")}
                            </span>
                            {x2.fromdate != x2.todate && (
                              <span
                                className="extra-small-dark-secondary"
                                style={{ marginRight: 4, marginLeft: 4 }}
                              >
                                -
                              </span>
                            )}
                            {x2.fromdate != x2.todate && (
                              <span className="extra-small-dark-secondary">
                                {moment(x2.todate).format("Do MMM")}
                              </span>
                            )}
                            <span
                              className="extra-small-dark-secondary"
                              style={{
                                marginRight: 2,
                                borderLeft: "solid 1px #6C6C6C",
                                paddingLeft: 8,
                                marginLeft: 8,
                              }}
                            >
                              <span
                                style={{
                                  marginRight: 2,
                                }}
                              >
                                {x2.leavedayscount}
                              </span>
                              <span>day(s)</span>
                            </span>
                          </div>
                        </div>
                        <Tooltip title={x2.leavename} placement="top-start">
                          <p className="extra-small-dark-secondary text-align-right ellipsis width30">
                            {x2.leavename}
                          </p>
                        </Tooltip>
                      </div>
                    ))}
                </div>
              )}

              {props.selectedeventtype == "events" && (
                <div>
                  {props.popupdata[0].event &&
                    props.popupdata[0].event.birthday &&
                    props.popupdata[0].event.birthday.length > 0 &&
                    props.popupdata[0].event.birthday.map((x) => (
                      <div
                        className="display-flex margin-bottom-16"
                        style={{ justifyContent: "space-between" }}
                      >
                        <div
                          className="display-flex"
                          style={{ justifyContent: "space-between" }}
                        >
                          <ProfilePicture
                            src={
                              x.imagepath
                                ? getFormattedImageLink(x.imagepath)
                                : defaultEmp
                            }
                            height="32"
                            classname="margin-right-16"
                            style={{ borderRadius: 20 }}
                          />
                          <div>
                            <p className="small-dark-secondary">{x.fullname}</p>

                            <span className="extra-small-dark-secondary">
                              Birthday
                            </span>
                          </div>
                        </div>

                        <img
                          src={birthdayEmoji}
                          style={{
                            backgroundColor: "#F9F9F9",
                            borderRadius: 20,
                            padding: 4,
                            height: 32,
                            width: 32,
                          }}
                        ></img>
                      </div>
                    ))}
                  {props.popupdata[0].event &&
                    props.popupdata[0].event.anniversary &&
                    props.popupdata[0].event.anniversary.length > 0 &&
                    props.popupdata[0].event.anniversary.map((x) => (
                      <div
                        className="display-flex margin-bottom-16"
                        style={{ justifyContent: "space-between" }}
                      >
                        <div
                          className="display-flex"
                          style={{ justifyContent: "space-between" }}
                        >
                          <ProfilePicture
                            src={
                              x.imagepath
                                ? getFormattedImageLink(x.imagepath)
                                : defaultEmp
                            }
                            height="32"
                            classname="margin-right-16"
                          />
                          <div>
                            <p className="small-dark-secondary">{x.fullname}</p>

                            <span className="extra-small-dark-secondary">
                              Marriage anniversary
                            </span>
                          </div>
                        </div>

                        <img
                          src={marriageAnniversaryEmoji}
                          style={{
                            backgroundColor: "#F9F9F9",
                            borderRadius: 20,
                            padding: 4,
                            height: 32,
                            width: 32,
                          }}
                        ></img>
                      </div>
                    ))}
                  {props.popupdata[0].event &&
                    props.popupdata[0].event.workanniversary &&
                    props.popupdata[0].event.workanniversary.length > 0 &&
                    props.popupdata[0].event.workanniversary.map((x) => (
                      <div
                        className="display-flex margin-bottom-16"
                        style={{ justifyContent: "space-between" }}
                      >
                        <div
                          className="display-flex"
                          style={{ justifyContent: "space-between" }}
                        >
                          <ProfilePicture
                            src={
                              x.imagepath
                                ? getFormattedImageLink(x.imagepath)
                                : defaultEmp
                            }
                            height="32"
                            classname="margin-right-16"
                          />
                          <div>
                            <p className="small-dark-secondary">{x.fullname}</p>

                            <span className="extra-small-dark-secondary">
                              Work anniversary
                            </span>
                          </div>
                        </div>

                        <img
                          src={workAnniversaryEmoji}
                          style={{
                            backgroundColor: "#F9F9F9",
                            borderRadius: 20,
                            padding: 4,
                            height: 32,
                            width: 32,
                          }}
                        ></img>
                      </div>
                    ))}
                  {props.popupdata[0].event &&
                    props.popupdata[0].event.newjoin &&
                    props.popupdata[0].event.newjoin.length > 0 &&
                    props.popupdata[0].event.newjoin.map((x) => (
                      <div
                        className="display-flex margin-bottom-16"
                        style={{ justifyContent: "space-between" }}
                      >
                        <div
                          className="display-flex"
                          style={{ justifyContent: "space-between" }}
                        >
                          <ProfilePicture
                            src={
                              x.imagepath
                                ? getFormattedImageLink(x.imagepath)
                                : defaultEmp
                            }
                            height="32"
                            classname="margin-right-16"
                          />
                          <div>
                            <p className="small-dark-secondary">{x.fullname}</p>

                            <span className="extra-small-dark-secondary">
                              New joining
                            </span>
                          </div>
                        </div>

                        <img
                          src={newJoiningEmoji}
                          style={{
                            backgroundColor: "#F9F9F9",
                            borderRadius: 20,
                            padding: 4,
                            height: 32,
                            width: 32,
                          }}
                        ></img>
                      </div>
                    ))}
                  {props.popupdata[0].event &&
                    props.popupdata[0].event.exit &&
                    props.popupdata[0].event.exit.length > 0 &&
                    props.popupdata[0].event.exit.map((x) => (
                      <div
                        className="display-flex margin-bottom-16"
                        style={{ justifyContent: "space-between" }}
                      >
                        <div
                          className="display-flex"
                          style={{ justifyContent: "space-between" }}
                        >
                          <ProfilePicture
                            src={
                              x.imagepath
                                ? getFormattedImageLink(x.imagepath)
                                : defaultEmp
                            }
                            height="32"
                            classname="margin-right-16"
                          />
                          <div>
                            <p className="small-dark-secondary">{x.fullname}</p>

                            <span className="extra-small-dark-secondary">
                              Last day (exit)
                            </span>
                          </div>
                        </div>
<div  style={{
                            backgroundColor: "#F9F9F9",
                            borderRadius: 20,
                            padding: 4,
                            height: 32,
                            width: 32,
                            textAlign:"center"
                          }}>
  <p style={{margin:"6px auto 0 auto"}}>👋</p>
</div>
                        {/* <img
                         // src={exitEmoji}
                          style={{
                            backgroundColor: "#F9F9F9",
                            borderRadius: 20,
                            padding: 4,
                            height: 32,
                            width: 32,
                          }}
                          alt="👋"
                        ></img> */}
                      </div>
                    ))}
                </div>
              )} 

              {props.selectedeventtype == "checklistitem" && (
                <div>
                  {props.popupdata[0].checklist &&
                    props.popupdata[0].checklist.length > 0 &&
                    props.popupdata[0].checklist.map((x) => (
                      <div className="checklist-popup-item">
                        <p className="extra-small-dark-secondary margin-bottom-4">
                          Checklist name
                        </p>
                        <p className="small-dark margin-bottom-16">
                          {x.checklistname}
                        </p>

                        <p className="extra-small-dark-secondary margin-bottom-4">
                          Activities due
                        </p>
                        {x.activity &&
                          x.activity.map((x) => (
                            <div
                              className="display-flex activities-list"
                              style={{ alignItems: "center" }}
                            >
                              <img
                                src={
                                  x.activitytypeid == 1
                                    ? msgIcon
                                    : x.activitytypeid == 2
                                    ? taskIcon
                                    : x.activitytypeid == 3
                                    ? mediaIcon
                                    : x.activitytypeid == 4
                                    ? linkIcon
                                    : x.activitytypeid == 5
                                    ? uploadIcon
                                    : dependancyIcon
                                }
                                height="16"
                              ></img>
                              <span className="small-dark margin-left-8">
                                {x.title}
                              </span>
                            </div>
                          ))}
                      </div>
                    ))}
                </div>
              )}

              {props.selectedeventtype == "reviewopen" && (
                <div>
                  {props.popupdata[0].reviewform &&
                    props.popupdata[0].reviewform.open &&
                    props.popupdata[0].reviewform.open.length > 0 &&
                    props.popupdata[0].reviewform.open.map((x2) => (
                      <div className="margin-bottom-16">
                        <p className="extra-small-dark-secondary margin-bottom-4">
                          Form name
                        </p>
                        <p className="small-dark margin-bottom-16">
                          {x2.formtitle}
                        </p>

                        <div className="display-flex">
                          {x2.period && (
                            <div className="margin-right-32">
                              <p className="extra-small-dark-secondary margin-bottom-4">
                                Review period
                              </p>
                              <p className="small-dark margin-bottom-16">
                                {x2.period}
                              </p>
                            </div>
                          )}
                          {x2.status && (
                            <div>
                              <p className="extra-small-dark-secondary margin-bottom-4">
                                Status
                              </p>
                              <p className="small-dark margin-bottom-16">
                                {x2.status}
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                </div>
              )}

              {props.selectedeventtype == "reviewclose" && (
                <div>
                  {props.popupdata[0].reviewform &&
                    props.popupdata[0].reviewform.close &&
                    props.popupdata[0].reviewform.close.length > 0 &&
                    props.popupdata[0].reviewform.close.map((x2) => (
                      <div className="margin-bottom-16">
                        <p className="extra-small-dark-secondary margin-bottom-4">
                          Form name
                        </p>
                        <p className="small-dark margin-bottom-16">
                          {x2.formtitle}
                        </p>

                        <div className="display-flex">
                          {x2.period && (
                            <div className="margin-right-32">
                              <p className="extra-small-dark-secondary margin-bottom-4">
                                Review period
                              </p>
                              <p className="small-dark margin-bottom-16">
                                {x2.period}
                              </p>
                            </div>
                          )}
                          {x2.status && (
                            <div>
                              <p className="extra-small-dark-secondary margin-bottom-4">
                                Status
                              </p>
                              <p className="small-dark margin-bottom-16">
                                {x2.status}
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                </div>
              )}

              {props.selectedeventtype == "payrollrun" && (
                <div className="margin-bottom-32 text-center">
                  {props.paysliploading == true ? (
                    <p>Downloading...</p>
                  ) : (
                    <Button
                      className={
                        props.popupdata[0].paryoll.length > 0
                          ? "btn btn-secondary-sm-blue"
                          : "btn btn-secondary-sm-grey"
                      }
                      onClick={() =>
                        props.downloadhtml(
                          props.popupdata[0].paryoll,
                          props.selectedDate,
                        )
                      }
                      startIcon={
                        <img src={downloadIcon} style={{ height: 16 }} />
                      }
                      style={{ width: "unset", fontSize: 14 }}
                    >
                      Download salary slip
                    </Button>
                  )}

                  {props.popupdata[0].paryoll.length > 0 ? (
                    ""
                  ) : (
                    <p className="small-dark margin-top-16">
                      Salary slip not generated yet
                    </p>
                  )}
                </div>
              )}

              {props.selectedeventtype == "shiftchange" && (
                <div>
                  {props.popupdata[0].shiftchange.map((x2) => (
                    <div className="checklist-popup-item">
                      <p className="extra-small-dark-secondary margin-bottom-4">
                        Shift name
                      </p>
                      <p className="small-dark margin-bottom-16">
                        {x2.shiftname}
                      </p>

                      <p className="extra-small-dark-secondary margin-bottom-4">
                        Shift type
                      </p>

                      <p className="small-dark margin-bottom-16">
                        {x2.shiftype}
                      </p>
                      {x2.shiftiming && x2.shiftiming[0] && (
                        <div className="display-flex">
                          <div>
                            {x2.shiftiming[1] ? (
                              <p className="small-dark-secondary margin-bottom-4">
                                1st shift timing
                              </p>
                            ) : (
                              <p className="small-dark-secondary margin-bottom-4">
                                Shift timing
                              </p>
                            )}
                            <p className="small-dark margin-bottom-16">
                              {getTime(x2.shiftiming[0].shiftbegintime)} to{" "}
                              {getTime(x2.shiftiming[0].shiftendtime)}
                            </p>
                          </div>
                          {x2.shiftiming[0] && x2.shiftiming[0].earlycutoff && (
                            <div className="margin-left-32">
                              <p className="small-dark-secondary margin-bottom-4">
                                Start-off
                              </p>
                              <p className="small-dark margin-bottom-16">
                                {x2.shiftiming[0] &&
                                  x2.shiftiming[0].earlycutoff}
                              </p>
                            </div>
                          )}
                          <div className="margin-left-32">
                            <p className="small-dark-secondary margin-bottom-4">
                              Cut-off
                            </p>
                            <p className="small-dark margin-bottom-16">
                              {x2.shiftiming[0] && x2.shiftiming[0].endcutoff}
                            </p>
                          </div>
                        </div>
                      )}
                      {x2.shiftiming && x2.shiftiming[1] && (
                        <div className="display-flex">
                          <div>
                            <p className="small-dark-secondary margin-bottom-4">
                              2nd shift timing
                            </p>
                            <p className="small-dark margin-bottom-16">
                              {getTime(x2.shiftiming[1].shiftbegintime)} to{" "}
                              {getTime(x2.shiftiming[1].shiftendtime)}
                            </p>
                          </div>
                          <div className="margin-left-32">
                            <p className="small-dark-secondary margin-bottom-4">
                              Start-off
                            </p>
                            <p className="small-dark margin-bottom-16">
                              {x2.shiftiming[1] && x2.shiftiming[1].earlycutoff}
                            </p>
                          </div>
                          <div className="margin-left-32">
                            <p className="small-dark-secondary margin-bottom-4">
                              Cut-off
                            </p>
                            <p className="small-dark margin-bottom-16">
                              {x2.shiftiming[1] && x2.shiftiming[1].endcutoff}
                            </p>
                          </div>
                        </div>
                      )}

                      <p className="extra-small-dark-secondary margin-bottom-4">
                        Clock-in method
                      </p>
                      {x2.clockinmethod &&
                        x2.clockinmethod.isbiometricdevice && (
                          <IconLabel
                            label="Biometric"
                            img={biometric}
                            labelClassNames="small-dark"
                            iconHeight="16"
                            className="margin-right-16 margin-bottom-12 cursor-pointer"
                          />
                        )}

                      {x2.clockinmethod && x2.clockinmethod.iswebdevice && (
                        <IconLabel
                          label="Web clock-in"
                          img={desktop}
                          labelClassNames="small-dark"
                          iconHeight="16"
                          className="margin-right-16 margin-bottom-12 cursor-pointer"
                        />
                      )}
                      {x2.clockinmethod && x2.clockinmethod.ismobiledevice && (
                        <IconLabel
                          label="Mobile clock-in"
                          img={mobileicon}
                          labelClassNames="small-dark"
                          iconHeight="16"
                          className="margin-right-16 cursor-pointer"
                        />
                      )}
                    </div>
                  ))}
                </div>
              )}
            </Paper>
          </Popover>
        )}
        {props.isshiftplan && props.selectedDate == props.events.event.start && (
          <Popover
            open={props.shiftdetails}
            anchorEl={props.shiftdetails_anchorEl}
            anchorOrigin={{
              vertical: "center",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "center",
              horizontal: "center",
            }}
            onClose={props.closedetails}
            style={{ background: "rgba(0,0,0,0.5)" }}
            classes={{
              paper: "calendar-paper",
            }}
          >
            <Paper
              className="thin-scroll"
              style={{
                width: 368,
                padding: 16,
                maxHeight: 400,
                overflowY: "auto",
              }}
            >
              <div
                className="display-flex margin-bottom-32"
                style={{ justifyContent: "space-between" }}
              >
                {/* <NavLink
                    to={props.selectedeventtype == "holiday" ? "/holiday" : ""}
                  > */}
                <div>
                  <IconLabel
                    label="Shift details"
                    img={Clock}
                    labelClassNames="small-dark t-bold"
                    iconHeight="16"
                    className="margin-right-16"
                  />
                </div>
                {/* </NavLink> */}
                <div className="display-flex">
                  <p className="small-dark-secondary margin-right-16">
                    {props.events.event.date}
                  </p>
                  <img
                    src={crossIcon}
                    onClick={props.closedetails}
                    className="cursor-pointer"
                  ></img>
                </div>
              </div>

              <div>
                <div className="">
                  <p className="extra-small-dark-secondary margin-bottom-4">
                    Shift name
                  </p>
                  <p className="small-dark margin-bottom-16">
                    {props.shiftdetaildata && props.shiftdetaildata.shiftname}
                  </p>

                  {props.shiftdetaildata1 &&
                    props.shiftdetaildata1.map((x) => (
                      <div className="display-flex">
                        <div>
                          <p className="small-dark-secondary margin-bottom-4">
                            Shift start time
                          </p>

                          <p className="small-dark margin-bottom-16">
                            {getFormattedDateTime(x.shiftbegintime)}
                          </p>
                        </div>

                        <div className="margin-left-32">
                          <p className="small-dark-secondary margin-bottom-4">
                            Shift end time
                          </p>

                          <p className="small-dark margin-bottom-16">
                            {getFormattedDateTime(x.shiftendtime)}
                          </p>
                        </div>
                      </div>
                    ))}

                  <p className="extra-small-dark-secondary margin-bottom-4">
                    Clock-in method
                  </p>
                  {props.shiftdetaildata &&
                    props.shiftdetaildata.isbiometricdevice && (
                      <IconLabel
                        label="Biometric"
                        img={biometric}
                        labelClassNames="small-dark"
                        iconHeight="16"
                        className="margin-right-16 margin-bottom-12 cursor-pointer"
                      />
                    )}

                  {props.shiftdetaildata &&
                    props.shiftdetaildata.iswebdevice && (
                      <IconLabel
                        label="Web clock-in"
                        img={desktop}
                        labelClassNames="small-dark"
                        iconHeight="16"
                        className="margin-right-16 margin-bottom-12 cursor-pointer"
                      />
                    )}
                  {props.shiftdetaildata &&
                    props.shiftdetaildata.ismobiledevice && (
                      <IconLabel
                        label="Mobile clock-in"
                        img={mobileicon}
                        labelClassNames="small-dark"
                        iconHeight="16"
                        className="margin-right-16 cursor-pointer"
                      />
                    )}
                  {props.shiftdetaildata &&
                  props.shiftdetaildata.clockinmodeid == 1 ? (
                    <p className="small-dark margin-bottom-16 margin-top-16">
                      Clock-in and Clock-out both are required
                    </p>
                  ) : (
                    <p className="small-dark margin-bottom-16 margin-top-16">
                      Only Clock-in required
                    </p>
                  )}
                </div>
                {/* ))} */}
              </div>
            </Paper>
          </Popover>
        )}
      </div>
    )}

    {props.selectedDate == props.events.event.start && (
      <Drawer
        anchor="right"
        open={props.MandatoryDrawerOpen}
        onClose={() => props.closeDrawer1()}
        style={{ padding: 40 }}
        classes={{
          paper: "planner-drawer width30 padding15",
        }}
      >
        <DrawerHeader
          header={`${
            props.data1 && props.data1.length > 0 && props.data1.length
          } employee(s) on holiday for ${
            props.data1 && props.data1.length > 0 && props.data1[0].holidayname
          }`}
          isbackarrow={false}
          closeDrawer={() => props.closeDrawer1()}
        />
        {props.data1 &&
          props.data1.length > 0 &&
          props.data1.map((emp) => (
            <div
              className="display-flex"
              style={{
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 16,
              }}
            >
              <div className="display-flex" style={{ alignItems: "center" }}>
                <img
                  src={
                    emp.imagepath
                      ? getFormattedImageLink(emp.imagepath)
                      : defaultEmp
                  }
                  height="32"
                  style={{ borderRadius: 20 }}
                ></img>
                <span className="normal-dark-secondary margin-left-16">
                  {emp.fullname}
                </span>
              </div>
            </div>
          ))}
      </Drawer>
    )}
    {props.selectedDate == props.events.event.start && (
      <Drawer
        anchor="right"
        open={props.OptionalDrawerOpen}
        onClose={() => props.closeDrawer()}
        style={{ padding: 40 }}
        classes={{
          paper: "planner-drawer width30 padding15",
        }}
      >
        <DrawerHeader
          header={`${
            props.data2 && props.data2.length > 0 && props.data2.length
          } employee(s) on holiday for ${
            props.data2 && props.data2.length > 0 && props.data2[0].holidayname
          }`}
          isbackarrow={false}
          closeDrawer={() => props.closeDrawer()}
        />

        {props.data2 &&
          props.data2.length > 0 &&
          props.data2.map((emp) => (
            <div
              className="display-flex"
              style={{
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 16,
              }}
            >
              <div className="display-flex" style={{ alignItems: "center" }}>
                <img
                  src={
                    emp.imagepath
                      ? getFormattedImageLink(emp.imagepath)
                      : defaultEmp
                  }
                  height="32"
                  style={{ borderRadius: 20 }}
                ></img>
                <span className="normal-dark-secondary margin-left-16">
                  {emp.fullname}
                </span>
              </div>
            </div>
          ))}
      </Drawer>
    )}
  </div>
);

// const CustomEvent = (event, props) => {
//   console.log(event);
//   return (
//     <span>
//       <strong> {event.title} </strong>
//       <p content="View" onClick={(e) => props.openeventdetails(e)}>
//         test{" "}
//       </p>
//     </span>
//   );
// };

class CustomToolbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(props.date),
    };
  }

  render() {
    const { label } = this.props;
    return (
      <div className="rbc-toolbar">
        <div
          className="cal-navigation display-flex width100"
          style={{ justifyContent: "center", alignItems: "center" }}
        >
          <img
            src={leftArrow}
            className=" cursor-pointer"
            onClick={() => this.props.onNavigate("PREV")}
            style={{ padding: "4px 12px" }}
          ></img>
          <p className="small-dark text-center" style={{ width: 262 }}>
            {label}
          </p>
          <img
            src={rightArrow}
            className="cursor-pointer"
            onClick={() => this.props.onNavigate("NEXT")}
            style={{ padding: "4px 12px" }}
          ></img>
        </div>
      </div>
    );
  }
}

class AppCalendar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      paysliploading: false,
      detailsloading: false,
      calendarview: "month",
      fromdate: new Date(),
      todate: new Date(),
      cardfilterids: [1, 2, 3],
      cardsubfilterids: [1, 2, 3, 4, 5, 6, 7, 8],
      empfilterid: 1,
      defaultEmp,
      alldata: [],
      loadMonthEventItem: false,
      ismanager: null,
      todaysdate: new Date(),

      OptionalDrawerOpen: false,
      MandatoryDrawerOpen: false,

      responsetypemenu: false,
      responsetype_anchorEl: null,
      eventdetails: false,
      eventdetails_anchorEl: null,
      shiftdetails: false,
      shiftdetaildata: null,
      shiftdetaildata1: [],
      shiftdetails_anchorEl: null,

      selectedDate: new Date(),
      defaultDate: new Date(),

      maxDate: new Date(),
      minDate: new Date(),
      weekviewdata: [],

      monthviewdata: [],
      popupdata: [],

      data1: [],
      data2: [],
      view: "month",
      selectedeventtype: null,

      holidayyear: new Date().getFullYear(),
    };

    this.getresponetypeopen = this.getresponetypeopen.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.GetEmpDetails = this.GetEmpDetails.bind(this);
    this.openeventdetails = this.openeventdetails.bind(this);
    this.openshiftdetails = this.openshiftdetails.bind(this);
    this.closedetails = this.closedetails.bind(this);
    this.getWeekView = this.getWeekView.bind(this);
    this.getSpecificWeekDetails = this.getSpecificWeekDetails.bind(this);
    this.getMonthView = this.getMonthView.bind(this);
    this.settodaydate = this.settodaydate.bind(this);
    this.applyfilter = this.applyfilter.bind(this);
    this.loadMonthEventItems = this.loadMonthEventItems.bind(this);
    this.getisemployeeManager = this.getisemployeeManager.bind(this);
    this.openDrawer = this.openDrawer.bind(this);
    this.openDrawer1 = this.openDrawer1.bind(this);
    this.closeDrawer = this.closeDrawer.bind(this);
    this.closeDrawer1 = this.closeDrawer1.bind(this);
    this.getData = this.getData.bind(this);
    this.selectCurrent = this.selectCurrent.bind(this);
    this.downloadhtml = this.downloadhtml.bind(this);
    this.getCommonConfig = this.getCommonConfig.bind(this);
  }

  componentDidMount() {
    this.getisemployeeManager();
    this.getCommonConfig();
    // if (window.location.pathname == "/calendar") {
    //   localStorage.removeItem("fromhome");
    //   // localStorage.removeItem("setdefaultdate");
    // }
    const isfromhome = localStorage.getItem("fromhome");

    const setdefaultdate = localStorage.getItem("setdefaultdate");

    const { holidayyear } = this.state;
    // const defaultDate = new Date(holidayyear, 0, 1);
    const defaultDate = new Date();
    // const selectedDate = new Date(holidayyear, 0, 1);
    // const selectedDate = isfromhome
    //   ? this.props.match.params.selecteddate
    //   : new Date(this.state.selectedDate);
    console.log("isfromhome: ", isfromhome);
    const selectedDate = isfromhome
      ? setdefaultdate
      : new Date(this.state.selectedDate);
    const minDate = new Date(holidayyear, 0, 0);
    const maxDate = new Date(holidayyear, 11, 32);
    const fromdate = moment(this.state.fromdate)
      .startOf("month")
      .format("YYYY-MM-DD");
    const todate = moment(this.state.todate)
      .endOf("month")
      .format("YYYY-MM-DD");

    if (isfromhome) {
      localStorage.removeItem("fromhome");

      this.setState(
        {
          fromdate: moment(setdefaultdate).startOf("week").format("YYYY-MM-DD"),

          todate: moment(setdefaultdate).endOf("week").format("YYYY-MM-DD"),
          empfilterid: 2,
          cardfilterids: [1, 2, 3, 4, 5, 6, 7],
          cardsubfilterids: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
          calendarview: "week",
          defaultDate: new Date(selectedDate),
          // defaultDate: moment(selectedDate).format("YYYY-MM-DD"),
        },
        () => {
          this.getSpecificWeekDetails();
        },
      );
    } else {
      this.setState({
        defaultDate,
        minDate,
        maxDate,
        selectedDate,
        todate,
        calendarview: "month",
      });
    }
  }

  getresponetypeopen(event) {
    this.setState({
      responsetypemenu: !this.state.responsetypemenu,
      responsetype_anchorEl: event.currentTarget,
    });
  }

  getCommonConfig() {
    instance
      .get("subscription/getcommonconfig")
      .then((result) => {
        this.setState({
          iscaldepartment: result.data.result[0]
            ? result.data.result[0].iscaldepartment
            : true,
          iscalorganization: result.data.result[0]
            ? result.data.result[0].iscalorganization
            : false,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  settodaydate() {
    const { calendarview, isshiftplan } = this.state;
    if (isshiftplan) {
      this.setState(
        {
          defaultDate: new Date(),
          selectedDate: new Date(),
          fromdate:
            calendarview == "month"
              ? moment(new Date()).startOf("month").format("YYYY-MM-DD")
              : moment(new Date()).startOf("week").format("YYYY-MM-DD"),
          todate:
            calendarview == "month"
              ? moment(new Date()).endOf("month").format("YYYY-MM-DD")
              : moment(new Date()).endOf("week").format("YYYY-MM-DD"),
        },
        () => this.GetEmpDetails(),
      );
    } else if (calendarview == "month") {
      this.setState(
        {
          defaultDate: new Date(),
          selectedDate: new Date(),
          fromdate: moment(new Date()).startOf("month").format("YYYY-MM-DD"),
          todate: moment(new Date()).endOf("month").format("YYYY-MM-DD"),
        },
        () => this.getMonthView(),
      );
    } else {
      this.setState(
        {
          defaultDate: new Date(),
          selectedDate: new Date(),
          fromdate: moment(new Date()).startOf("week").format("YYYY-MM-DD"),
          todate: moment(new Date()).endOf("week").format("YYYY-MM-DD"),
        },
        () => this.getWeekView(),
      );
    }
  }

  getData(payrolldata) {
    // console.log("payrolldata: ", payrolldata);

    if (payrolldata) {
      const data = {
        payrollcycledurationid:
          payrolldata && payrolldata.payrollcycledurationid,
        salarycycleid: payrolldata && payrolldata.salarycycleid,
        salarycyclesplitid: payrolldata && payrolldata.salarycyclesplitid,
        // employeeid: 351,
        employeeid: payrolldata && payrolldata.employeeid,
        empsalarysheetid: payrolldata && payrolldata.empsalarysheetid,
        ispayslipgenerated: payrolldata.ispayslipgenerated,

        monthname: getMonthName(payrolldata && payrolldata.payrollmonthid),
        year: payrolldata && payrolldata.payrollyear,
        monthid: payrolldata && payrolldata.payrollmonthid,
        salaryto: payrolldata && payrolldata.salaryto,
        // cycleto: payrolldata.cycleto,
        // cyclefrom: payrolldata.cyclefrom,
        isview: false,
        // ispayslipgenerated: true,
      };

      this.setState({ paysliploading: true }, () => {
        instance
          .post(`payroll/salarysliphtml`, data)
          .then((resp) => {
            if (resp.data.result.length > 0) {
              const link = `data:application/pdf;base64,${get(
                resp,
                "data.result[0].paysliphtml",
                "",
              )}`;
              const downloadLink = document.createElement("a");
              const fileName = `${get(resp, "data.result[0].firstname", "")}_${
                get(resp, "data.result[0].lastname", null)
                  ? `${get(resp, "data.result[0].lastname", null)}_`
                  : ""
              }Payslip_${getMonthName(
                payrolldata && payrolldata.payrollmonthid,
              )}_${payrolldata && payrolldata.payrollyear}.pdf`;
              downloadLink.href = link;
              downloadLink.download = fileName;
              downloadLink.click();

              this.setState({
                pdfurl: this.state.pdfurl,

                paysliploading: false,
                // drcv: d,
                // advances: ad,
              });
            } else {
              this.setState({ paysliploading: false });
            }
          })
          .catch((error) => {
            this.setState({
              // drcv: d,
              // advances: ad,
              paysliploading: false,
            });
            this.props.enqueueSnackbar(
              error.response
                ? error.response.data.error.message
                : error.message,
              { variant: "error" },
            );
          });
      });
    }
  }

  downloadhtml(selectedmonth1, selectedDate) {
    // console.log("selectedDate: ", selectedDate);
    // console.log("selectedmonth1: ", selectedmonth1);
    const { pdfurl } = this.state;

    const payrolldata = selectedmonth1.filter(
      (x) =>
        moment(x.start).format("YYYY-MM-DD") ==
        moment(selectedDate).format("YYYY-MM-DD"),
    );

    console.log("selectedDate: ", payrolldata);

    // if (pdfurl) {
    //   this.getData(payrolldata[0].paryoll[0]);
    // } else {
    //   this.getData(payrolldata[0].paryoll[0]);
    // }

    this.getData(payrolldata[0].paryoll[0]);
  }

  groupBy(list, keyGetter) {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }

  openeventdetails(
    e,
    type,
    date,
    dataman,
    dataopt,
    cardfilterids,
    cardsubfilterids,
  ) {
    const data = {
      fromdate: moment(date).format("YYYY-MM-DD"),
      todate: moment(date).format("YYYY-MM-DD"),
      empfilterid: this.state.empfilterid,
      cardfilterids,
      cardsubfilterids,
    };
    this.setState({ detailsloading: true }, () => {
      instance
        .post(`trackdashboard/getdetailview`, data)
        .then((result) => {
          this.setState(
            {
              popupdata: result.data.result
                ? result.data.result.map((x) => {
                    const holidaydate = x.date.split("-");
                    const year = holidaydate[0];
                    const month = holidaydate[1];
                    const day = holidaydate[2];
                    return {
                      ...x,
                      end: new Date(year, month - 1, day),
                      start: new Date(year, month - 1, day),
                    };
                  })
                : [],
              detailsloading: false,
            },
            () => this.detailedData(e, type, date, dataman, dataopt),
          );
        })
        .catch((error) => {
          this.setState({ detailsloading: false });
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    });

    // this.setState(
    //   {
    //     eventdetails: !this.state.eventdetails,
    //     eventdetails_anchorEl: e.currentTarget,
    //     selectedeventtype: type,
    //     selectedDate: date,

    //     data1: data,
    //     data2: dataopt,

    //   },

    // );
  }

  openshiftdetails(
    e,
    type,
    date,

    data,
  ) {
    console.log("date: ", date);

    instance
      .post("attendance/actualshifttiming", {
        shiftdate: moment(date).format("YYYY-MM-DD"),
        shiftid: data.shiftid ? data.shiftid : null,
        employeeid:
          this.props.AuthenticationAction &&
          this.props.AuthenticationAction.login &&
          this.props.AuthenticationAction.login.employeeid,
        shifttimingid: null,
      })
      .then((result) => {
        this.setState({
          selectedDate: date,
          shiftdetaildata: result.data.result[0],
          shiftdetaildata1: result.data.result,
          shiftdetails: true,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });

    // this.setState(
    //   {
    //     eventdetails: !this.state.eventdetails,
    //     eventdetails_anchorEl: e.currentTarget,
    //     selectedeventtype: type,
    //     selectedDate: date,

    //     data1: data,
    //     data2: dataopt,

    //   },

    // );
  }

  detailedData(e, type, date, dataman, dataopt) {
    this.setState({
      eventdetails: !this.state.eventdetails,
      eventdetails_anchorEl: e.currentTarget,
      selectedeventtype: type,
      selectedDate: date,
      data1: dataman,
      data2: dataopt,
    });
  }

  openDrawer() {
    this.setState({
      OptionalDrawerOpen: true,
      eventdetails: false,
    });
  }

  openDrawer1() {
    this.setState({
      MandatoryDrawerOpen: true,
      eventdetails: false,
    });
  }

  closeDrawer() {
    this.setState({
      OptionalDrawerOpen: false,
    });
  }

  closeDrawer1() {
    this.setState({
      MandatoryDrawerOpen: false,
    });
  }

  loadMonthEventItems() {
    // this.setState({
    //   responsetypemenu: !this.state.responsetypemenu,
    //   responsetype_anchorEl: event.currentTarget,
    // });
    console.log("abcddd");
    const second = document.querySelector(
      "ul.month-view-item-list .calendar-list-item:nth-child(2)",
    );
    console.log(second);
  }

  closedetails() {
    this.setState({
      eventdetails: false,
      eventdetails_anchorEl: null,
      selectedeventtype: null,
      // shiftdetaildata: null,
      shiftdetails: false,
      // selectedDate: date,
      // selectedDate:new Date(),
    });
  }

  showLoader() {
    return <div className="pre-loader">Loading...</div>;
  }

  getWeekView() {
    localStorage.removeItem("setdefaultdate");
    const data = {
      fromdate: moment(this.state.selectedDate)
        .startOf("week")
        .format("YYYY-MM-DD"),
      todate: moment(this.state.selectedDate)
        .endOf("week")
        .format("YYYY-MM-DD"),
      empfilterid: this.state.empfilterid,
      cardfilterids: this.state.cardfilterids,
      cardsubfilterids: this.state.cardsubfilterids,
    };

    this.setState({ loading: true }, () => {
      instance
        .post(`trackdashboard/getdetailview`, data)
        .then((result) => {
          this.setState({
            templistdata: false,
            weekviewdata: result.data.result
              ? result.data.result.map((x) => {
                  const holidaydate = x.date.split("-");
                  const year = holidaydate[0];
                  const month = holidaydate[1];
                  const day = holidaydate[2];
                  return {
                    ...x,
                    end: new Date(year, month - 1, day),
                    start: new Date(year, month - 1, day),
                  };
                })
              : [],

            responsetypemenu: false,
            responsetype_anchorEl: null,
            view: this.state.calendarview,
            loading: false,
            defaultDate: new Date(this.state.selectedDate),
          });
        })
        .catch((error) => {
          this.setState({ loading: false });
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    });
  }

  getSpecificWeekDetails() {
    const data = {
      fromdate: moment(this.state.fromdate)
        .startOf("week")
        .format("YYYY-MM-DD"),
      todate: moment(this.state.todate).endOf("week").format("YYYY-MM-DD"),
      empfilterid: this.state.empfilterid,
      cardfilterids: this.state.cardfilterids,
      cardsubfilterids: this.state.cardsubfilterids,
    };

    this.setState({ loading: true }, () => {
      instance
        .post(`trackdashboard/getdetailview`, data)
        .then((result) => {
          this.setState({
            weekviewdata: result.data.result
              ? result.data.result.map((x) => {
                  const holidaydate = x.date.split("-");
                  const year = holidaydate[0];
                  const month = holidaydate[1];
                  const day = holidaydate[2];
                  return {
                    ...x,
                    end: new Date(year, month - 1, day),
                    start: new Date(year, month - 1, day),
                  };
                })
              : [],

            responsetypemenu: false,
            responsetype_anchorEl: null,
            view: this.state.calendarview,
            loading: false,
          });
        })
        .catch((error) => {
          this.setState({ loading: false });
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    });
  }

  getMonthView() {
    const data = {
      fromdate: moment(this.state.selectedDate)
        .startOf("month")
        .format("YYYY-MM-DD"),
      todate: moment(this.state.selectedDate)
        .endOf("month")
        .format("YYYY-MM-DD"),
      empfilterid: this.state.empfilterid,
      cardfilterids: this.state.cardfilterids,
      cardsubfilterids: this.state.cardsubfilterids,
      limit: this.state.limit,
      offset: this.state.offset,
    };

    this.setState({ loading: true }, () => {
      instance
        .post(`trackdashboard/getmonthview`, data)
        .then((result) => {
          if (result.data.result.length > 0) {
            this.setState(
              {
                templistdata: false,
                monthviewdata: result.data.result
                  ? result.data.result.map((x) => {
                      const holidaydate = x.date.split("-");
                      const year = holidaydate[0];
                      const month = holidaydate[1];
                      const day = holidaydate[2];
                      return {
                        ...x,
                        end: new Date(year, month - 1, day),
                        start: new Date(year, month - 1, day),
                      };
                    })
                  : [],
                responsetypemenu: false,
                responsetype_anchorEl: null,
                view: this.state.calendarview,
                loading: false,
              },
              // () => this.getWeekView(),
            );
          } else {
            this.setState({ loading: false });
          }
        })
        .catch((error) => {
          this.setState({ loading: false });
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    });
  }

  applyfilter() {
    const data = {
      fromdate: moment(this.state.fromdate)
        .startOf("month")
        .format("YYYY-MM-DD"),
      todate: moment(this.state.todate).endOf("month").format("YYYY-MM-DD"),
      empfilterid: this.state.empfilterid,
      cardfilterids: this.state.cardfilterids,
      cardsubfilterids: this.state.cardsubfilterids,
    };

    instance
      .post(`trackdashboard/getdetailview`, data)
      .then((result) => {
        this.setState({
          weekviewdata: result.data.result
            ? result.data.result.map((x) => {
                const holidaydate = x.date.split("-");
                const year = holidaydate[0];
                const month = holidaydate[1];
                const day = holidaydate[2];
                return {
                  ...x,
                  end: new Date(year, month - 1, day),
                  start: new Date(year, month - 1, day),
                };
              })
            : [],
          responsetypemenu: false,
          responsetype_anchorEl: null,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  selectCurrent(args) {
    const selectedDate = args;

    this.setState({
      selectedDate,
    });
    // this.getMonthView();
  }

  GetEmpDetails() {
    const feature = GetFeature("attendance");
    this.setState({ loading: true }, () => {
      const URL = "/attendance/loadsusbriptionshiftplanner";
      const data = {
        limit: 100,
        offset: 0,
        fromdate:
          this.state.calendarview == "week"
            ? moment(this.state.selectedDate)
                .startOf("week")
                .format("YYYY-MM-DD")
            : moment(this.state.selectedDate)
                .startOf("month")
                .format("YYYY-MM-DD"),
        // employeeids: employeeid ? [employeeid] : this.state.selectedEmployeeIds,
        todate:
          this.state.calendarview == "week"
            ? moment(this.state.selectedDate).endOf("week").format("YYYY-MM-DD")
            : moment(this.state.selectedDate)
                .endOf("month")
                .format("YYYY-MM-DD"),
        designationids: null,
        officeaddressids: null,
        weekoffpolicyid: null,
        shiftid: null,
        attendancepolicyid: null,
        devicepolicyid: null,
        teamids: null,
        // profilemenuactionid: null,
        departmentids: null,
        ismyshiftplan: true,
        statusid: 1,
        // employeestatusid: 1,
        stageid: null,
        featurekey: "planner_shift",
      };
      this.setState({ tempList: [] }, () => {
        instance
          .post(URL, data)
          .then((result) => {
            this.setState({
              responsetypemenu: false,
              templistdata: true,
              // tempList: result.data.result[0].planner,
              tempList: result.data.result[0].planner
                ? result.data.result[0].planner.map((x) => {
                    const holidaydate = x.date.split("-");
                    console.log("holidaydate: ", holidaydate);
                    const year = holidaydate[0];
                    const month = holidaydate[1];
                    const day = holidaydate[2];
                    return {
                      ...x,
                      end: new Date(year, month - 1, day),
                      start: new Date(year, month - 1, day),
                    };
                  })
                : [],
              loading: false,
              view: this.state.calendarview,
              // EmpDetails,
              // selectedProfileEmpList: [],
              // selectedProfileEmpList: [],
            });
          })
          .catch((error) => {
            // APIINPROGESS = false;
            this.setState({ loading: false });
            const CommonError = error.response
              ? error.response.data.error.message
              : error.message;
            this.props.enqueueSnackbar(CommonError, { variant: "error" });
          });
      });
      // });
    });
  }

  handleChange(key, value, isdata = false) {
    console.log("value: ", value);
    const { cardfilterids, cardsubfilterids } = this.state;

    if (key == "cardfilterids") {
      this.setState({
        empfilterid: this.state.isshiftplan
          ? this.state.ismanager
            ? 1
            : 2
          : this.state.empfilterid,
        isshiftplan: false,
      });
      const isexit = cardfilterids.findIndex((x) => x == value);
      console.log("isexit: ", isexit);
      if (isexit == -1) {
        console.log("yes");
        cardfilterids.push(value);
        if (value == 1) {
          cardsubfilterids.push(1);
        } else if (value == 2) {
          cardsubfilterids.push(2, 3);
        } else if (value == 3) {
          cardsubfilterids.push(4, 5, 6, 7, 8);
        } else if (value == 6) {
          cardsubfilterids.push(9, 10);
        } else {
          // cardsubfilterids.push();
        }
        this.setState({ cardfilterids, cardsubfilterids });
      } else {
        console.log("no");
        cardfilterids.splice(isexit, 1);
        if (value == 1) {
          const index = cardsubfilterids.indexOf(1);
          cardsubfilterids.splice(index, 1);
        } else if (value == 2) {
          const index1 = cardsubfilterids.indexOf(2);
          cardsubfilterids.splice(index1, 1);
          const index2 = cardsubfilterids.indexOf(3);
          cardsubfilterids.splice(index2, 1);
        } else if (value == 3) {
          const index3 = cardsubfilterids.indexOf(4);
          cardsubfilterids.splice(index3, 1);
          const index4 = cardsubfilterids.indexOf(5);
          cardsubfilterids.splice(index4, 1);
          const index5 = cardsubfilterids.indexOf(6);
          cardsubfilterids.splice(index5, 1);
          const index6 = cardsubfilterids.indexOf(7);
          cardsubfilterids.splice(index6, 1);
          const index7 = cardsubfilterids.indexOf(8);
          cardsubfilterids.splice(index7, 1);
        } else if (value == 6) {
          const index8 = cardsubfilterids.indexOf(9);
          cardsubfilterids.splice(index8, 1);
          const index9 = cardsubfilterids.indexOf(10);
          cardsubfilterids.splice(index9, 1);
        } else {
        }

        this.setState({ cardfilterids, cardsubfilterids });
      }
    } else {
      this.setState({ [key]: value });
      if (isdata) {
        this.setState({
          cardfilterids: this.state.isshiftplan ? [] : [1, 2, 3],
          cardsubfilterids: this.state.isshiftplan
            ? []
            : [1, 2, 3, 4, 5, 6, 7, 8],
        });
      }
    }
  }

  // Navigate = (date, x, y) => {
  //   console.log("date, x, y: ", date, x, y);
  //   this.setState({
  //     defaultDate:
  //       moment(date).format("MM") ==
  //       moment(this.state.fromdate, "YYYY-MM-DD").format("MM")
  //         ? this.state.fromdate
  //         : this.state.todate,
  //   });
  // };

  Navigate(selectedDate, x, y) {
    console.log("x: ", x);
    const { calendarview, isshiftplan } = this.state;
    // console.log('isshiftplan: ', isshiftplan);
    // this.HelperSliderFlag(["HtCalenderDateSelection"]);
    if (
      // new Date(this.state.minDate) < new Date(selectedDate) &&
      // new Date(this.state.maxDate) > new Date(selectedDate) &&
      y == "NEXT" &&
      x == "isshiftplan"
    ) {
      this.setState(
        {
          defaultDate: selectedDate,
          selectedDate,
          // fromdate:
          //   calendarview == "month"
          //     ? moment(this.state.selectedDate)
          //         .add(1, "month")
          //         .startOf("month")
          //         .format("YYYY-MM-DD")
          //     : moment(this.state.selectedDate)
          //         .add(1, "month")
          //         .startOf("month")
          //         .format("YYYY-MM-DD"),
          fromdate: moment(this.state.selectedDate)
            .add(1, "month")
            .startOf("month")
            .format("YYYY-MM-DD"),
          // todate:
          //   calendarview == "month"
          //     ? moment(this.state.selectedDate)
          //         .add(1, "month")
          //         .endOf("month")
          //         .format("YYYY-MM-DD")
          //     : moment(this.state.selectedDate)
          //         .add(1, "month")
          //         .endOf("month")
          //         .format("YYYY-MM-DD"),
          todate: moment(this.state.selectedDate)
            .add(1, "month")
            .endOf("month")
            .format("YYYY-MM-DD"),
        },

        () => {
          this.GetEmpDetails();
        },
      );
    } else if (y == "PREV" && x == "isshiftplan") {
      this.setState(
        {
          defaultDate: selectedDate,
          selectedDate,
          fromdate:
            calendarview == "month"
              ? moment(this.state.selectedDate)
                  .subtract(1, "month")
                  .startOf("month")
                  .format("YYYY-MM-DD")
              : moment(this.state.selectedDate)
                  .subtract(1, "month")
                  .endOf("month")
                  .format("YYYY-MM-DD"),
          todate:
            calendarview == "month"
              ? moment(this.state.selectedDate)
                  .subtract(1, "month")
                  .endOf("month")
                  .format("YYYY-MM-DD")
              : moment(this.state.selectedDate)
                  .subtract(1, "month")
                  .endOf("month")
                  .format("YYYY-MM-DD"),
        },
        () => {
          this.GetEmpDetails();
        },
      );
    } else if (
      // new Date(this.state.minDate) < new Date(selectedDate) &&
      // new Date(this.state.maxDate) > new Date(selectedDate) &&
      y == "NEXT" &&
      x == "month"
    ) {
      this.setState(
        {
          defaultDate: selectedDate,
          selectedDate,
          fromdate: moment(this.state.selectedDate)
            .add(1, "month")
            .startOf("month")
            .format("YYYY-MM-DD"),
          todate: moment(this.state.selectedDate)
            .add(1, "month")
            .endOf("month")
            .format("YYYY-MM-DD"),
        },
        () => {
          this.getMonthView();
        },
      );
    } else if (y == "PREV" && x == "month") {
      this.setState(
        {
          defaultDate: selectedDate,
          selectedDate,
          fromdate: moment(this.state.selectedDate)
            .subtract(1, "month")
            .startOf("month")
            .format("YYYY-MM-DD"),
          todate: moment(this.state.selectedDate)
            .subtract(1, "month")
            .endOf("month")
            .format("YYYY-MM-DD"),
        },
        () => {
          this.getMonthView();
        },
      );
    } else if (y == "NEXT" && x == "week") {
      this.setState(
        {
          defaultDate: selectedDate,
          selectedDate,
          fromdate: moment(this.state.selectedDate)
            .add(1, "month")
            .startOf("month")
            .format("YYYY-MM-DD"),
          todate: moment(this.state.selectedDate)
            .add(1, "month")
            .endOf("month")
            .format("YYYY-MM-DD"),
        },
        () => {
          this.getWeekView();
        },
      );
    } else if (y == "PREV" && x == "week") {
      this.setState(
        {
          defaultDate: selectedDate,
          selectedDate,
          fromdate: moment(this.state.selectedDate)
            .subtract(1, "month")
            .startOf("month")
            .format("YYYY-MM-DD"),
          todate: moment(this.state.selectedDate)
            .subtract(1, "month")
            .endOf("month")
            .format("YYYY-MM-DD"),
        },
        () => {
          this.getWeekView();
        },
      );
    } else {
    }
  }

  eventStyleGetter(event) {
    const style = [];
    return {
      style: {
        backgroundColor: event.shiftcolour,
        color: "#000",
      },
    };
  }

  getisemployeeManager() {
    const employeeid =
      this.props.AuthenticationAction &&
      this.props.AuthenticationAction.login &&
      this.props.AuthenticationAction.login.employeeid;
    instance
      .get(`/trackdashboard/isemployeemanager/${employeeid}`)
      .then((result) => {
        this.setState(
          {
            ismanager: result.data.result[0].ismanager,
            empfilterid:
              result.data.result[0].ismanager == false
                ? 2
                : this.state.empfilterid,
          },
          () => this.getMonthView(),
          // () => this.getWeekView(),
        );
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  render() {
    const {
      fromdate,
      todate,
      // defaultDate = "",
    } = this.state;

    return (
      <div className="appcalendar-wrapper">
        <Helmet>
          <title>{headersList.Calendar.header}</title>
        </Helmet>
        <div
          className="display-flex"
          style={{
            justifyContent: "space-between",
            alignItems: "center",
            position: "relative",
            // zIndex: 21,
          }}
        >
          <div
            className="display-flex"
            style={{
              alignItems: "center",
              position: "relative",
              zIndex: 20,
              width: 180,
            }}
          >
            <p className="large-text-dark t-bold">Calendar </p>
            <div
              style={{
                marginLeft: 24,
                width: 101,
                borderRadius: 5,
                border: "solid 1px #1E8CED",
                padding: "6px 16px",
                background: "#EDF5FD",
                display: "flex",
                cursor: "pointer",
              }}
              // onClick={() =>
              //   this.setState(
              //     {
              //       defaultDate: new Date(),
              //       selectedDate: new Date(),
              //       fromdate: moment(new Date())
              //         .startOf("month")
              //         .format("YYYY-MM-DD"),
              //       todate: moment(new Date())
              //         .endOf("month")
              //         .format("YYYY-MM-DD"),
              //     },
              //     () => this.getMonthView(),
              //   )
              // }

              onClick={this.settodaydate}
            >
              <img src={calendarIcon}></img>
              <p className="small-blue margin-left-8">Today</p>
            </div>
          </div>

          <div
            className="rounded-rectangle-div padding8 display-flex margin-bottom-16 position-rel cursor-pointer"
            style={{
              justifyContent: "space-between",
              width: 208,
              position: "relative",
              zIndex: 20,
            }}
            onClick={this.getresponetypeopen}
          >
            <p className="small-dark-secondary margin-right-8 width80">
              {this.state.view == "week" ? "Week" : "Month"} - &nbsp;
              {this.state.empfilterid == 1
                ? "Direct reports"
                : this.state.empfilterid == 2
                ? "My department"
                : this.state.empfilterid == 3
                ? "Organisation"
                : "Self"}
            </p>
            <img
              src={downArrow}
              style={{ position: "absolute", right: 8, top: 10 }}
            ></img>
          </div>

          <Popover
            open={this.state.responsetypemenu}
            anchorEl={this.state.responsetype_anchorEl}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            onClose={() => this.setState({ responsetypemenu: false })}
            className="margin-top-8"
          >
            <Paper
              className="rounded-rectangle-div"
              style={{ padding: 16, width: 430 }}
            >
              <Grid container className="display-flex" spacing={3}>
                <Grid item xs={12} md={6} sm={12}>
                  <List style={{ paddingTop: 0 }}>
                    <ListSubheader
                      style={{
                        paddingLeft: 0,
                        fontWeight: "bold",
                        lineHeight: "32px",
                        color: " #545556",
                        // marginTop: 8,
                      }}
                    >
                      Office data
                    </ListSubheader>
                    <ListItem style={{ padding: "8px 0px" }}>
                      <ListItemIcon style={{ height: 24 }}>
                        <DynamicForm
                          fields={checkboxinputconverter({
                            value:
                              this.state.cardfilterids.indexOf(1) == -1
                                ? false
                                : true,
                            placeholder: "",
                            label: "Leaves",
                            labelclass: "small-dark-secondary width100",
                          })}
                          onChange={() => {
                            this.handleChange("cardfilterids", 1);
                          }}
                        />
                      </ListItemIcon>
                      <ListItemSecondaryAction style={{ right: 0 }}>
                        <span
                          className="dot"
                          style={{
                            backgroundColor: "#2D75FF",
                            display: "block",
                            height: 14,
                            width: 14,
                            borderRadius: 18,
                          }}
                        ></span>
                      </ListItemSecondaryAction>
                      {/* <p className="small-dark-secondary margin-left-8">Leaves</p> */}
                    </ListItem>
                    <ListItem style={{ padding: "8px 0px" }}>
                      <ListItemIcon style={{ height: 24 }}>
                        <DynamicForm
                          fields={checkboxinputconverter({
                            value:
                              this.state.cardfilterids.indexOf(2) == -1
                                ? false
                                : true,
                            placeholder: "",
                            label: "Holidays",
                            labelclass: "small-dark-secondary width100",
                          })}
                          onChange={() => {
                            this.handleChange("cardfilterids", 2);
                          }}
                        />
                      </ListItemIcon>
                      <ListItemSecondaryAction style={{ right: 0 }}>
                        <span
                          className="dot"
                          style={{
                            backgroundColor: "#FF45E4",
                            display: "block",
                            height: 14,
                            width: 14,
                            borderRadius: 18,
                          }}
                        ></span>
                      </ListItemSecondaryAction>
                      {/* <p className="small-dark-secondary margin-left-8">Holidays</p> */}
                    </ListItem>
                    <ListItem style={{ padding: "8px 0px" }}>
                      <ListItemIcon style={{ height: 24 }}>
                        <DynamicForm
                          fields={checkboxinputconverter({
                            value:
                              this.state.cardfilterids.indexOf(3) == -1
                                ? false
                                : true,
                            placeholder: "",
                            label: "Events",
                            labelclass: "small-dark-secondary width100",
                          })}
                          onChange={() => {
                            this.handleChange("cardfilterids", 3);
                          }}
                        />
                      </ListItemIcon>
                      <ListItemSecondaryAction style={{ right: 0 }}>
                        <span
                          className="dot"
                          style={{
                            backgroundColor: "#FF653B",
                            height: 14,
                            width: 14,
                            borderRadius: 18,
                            display: "block",
                          }}
                        ></span>
                      </ListItemSecondaryAction>
                      {/* <p className="small-dark-secondary margin-left-8">Events</p> */}
                    </ListItem>

                    {/* <ListItem style={{ padding: "8px 0px" }}>
                  <ListItemIcon style={{ height: 24 }}>
                    <DynamicForm
                      className="width100"
                      fields={radioinputconverter({
                        value: this.state.calendarview == "month",
                        label: "Month - Overview",
                        labelclass: "small-dark-secondary width100",
                        // disabled: this.state.check && this.state.check.editable ? false : true,
                      })}
                      onChange={() =>
                        this.handleChange("calendarview", "month")
                      }
                    />
                  </ListItemIcon> */}
                    {/* <p className="small-dark-secondary margin-left-8">
                    Month - Overview
                  </p> */}
                    {/* </ListItem>
                <ListItem style={{ padding: "8px 0px" }}>
                  <ListItemIcon style={{ height: 24 }}>
                    <DynamicForm
                      className="width100"
                      fields={radioinputconverter({
                        value: this.state.calendarview == "week",
                        label: " Week - Detailed",
                        labelclass: "small-dark-secondary width100",
                        // disabled: this.state.check && this.state.check.editable ? false : true,
                      })}
                      onChange={() => this.handleChange("calendarview", "week")}
                    />
                  </ListItemIcon> */}
                    {/* <p className="small-dark-secondary margin-left-8">
                    Week - Detailed
                  </p> */}
                    {/* </ListItem> */}

                    {/* <Divider
                  style={{
                    marginLeft: -16,
                    width: "calc(100% + 32px)",
                    marginTop: 8,
                    marginBottom: 8,
                  }}
                /> */}
                    {/* {this.state.ismanager && (
                  <ListItem style={{ padding: "8px 0px" }}>
                    <ListItemIcon style={{ height: 24 }}>
                      <DynamicForm
                        className="width100"
                        fields={radioinputconverter({
                          value: this.state.empfilterid == 1,
                          label: "Direct reports",
                          labelclass: "small-dark-secondary width100",
                          // disabled: this.state.check && this.state.check.editable ? false : true,
                        })}
                        onChange={() => this.handleChange("empfilterid", 1)}
                      />
                    </ListItemIcon>

                  </ListItem>
                )} */}
                    {/* <ListItem style={{ padding: "8px 0px" }}>
                  <ListItemIcon style={{ height: 24 }}>
                    <DynamicForm
                      className="width100"
                      fields={radioinputconverter({
                        value: this.state.empfilterid == 2,
                        label: " My department",
                        labelclass: "small-dark-secondary width100",
                        // disabled: this.state.check && this.state.check.editable ? false : true,
                      })}
                      onChange={() => this.handleChange("empfilterid", 2)}
                    />
                  </ListItemIcon>

                </ListItem> */}

                    {/* {this.props.AuthenticationAction
                  && this.props.AuthenticationAction.login
                  && this.props.AuthenticationAction.login.masterprofileid
                  && this.props.AuthenticationAction.login.masterprofileid
                    == 9 && (
                    <ListItem style={{ padding: "8px 0px" }}>
                      <ListItemIcon style={{ height: 24 }}>
                        <DynamicForm
                          className="width100"
                          fields={radioinputconverter({
                            value: this.state.empfilterid == 3,
                            label: "Organization",
                            labelclass: "small-dark-secondary width100",
                            // disabled: this.state.check && this.state.check.editable ? false : true,
                          })}
                          onChange={() => this.handleChange("empfilterid", 3)}
                        />
                      </ListItemIcon>

                    </ListItem>
                  )} */}
                    {/* <Divider
                  style={{
                    marginLeft: -16,
                    width: "calc(100% + 32px)",
                    marginTop: 8,
                    marginBottom: 8,
                  }}
                /> */}

                    <ListSubheader
                      style={{
                        paddingLeft: 0,
                        fontWeight: "bold",
                        lineHeight: "32px",
                        color: " #545556",
                        marginTop: 8,
                      }}
                    >
                      My data
                    </ListSubheader>
                    <ListItem style={{ padding: "8px 0px" }}>
                      <ListItemIcon style={{ height: 24 }}>
                        <DynamicForm
                          fields={checkboxinputconverter({
                            value:
                              this.state.cardfilterids.indexOf(4) == -1
                                ? false
                                : true,
                            placeholder: "",
                            label: "Shift change",
                            labelclass: "small-dark-secondary width100",
                          })}
                          onChange={() => {
                            this.handleChange("cardfilterids", 4);
                          }}
                        />
                      </ListItemIcon>
                      <ListItemSecondaryAction style={{ right: 0 }}>
                        <span
                          className="dot"
                          style={{
                            backgroundColor: "#FAC710",
                            height: 14,
                            width: 14,
                            borderRadius: 18,
                            display: "block",
                          }}
                        ></span>
                      </ListItemSecondaryAction>
                      {/* <p className="small-dark-secondary margin-left-8">
                    Shift change
                  </p> */}
                    </ListItem>
                    <ListItem style={{ padding: "8px 0px" }}>
                      <ListItemIcon style={{ height: 24 }}>
                        <DynamicForm
                          fields={checkboxinputconverter({
                            value:
                              this.state.cardfilterids.indexOf(5) == -1
                                ? false
                                : true,
                            placeholder: "",
                            label: "Checklist items",
                            labelclass: "small-dark-secondary width100",
                          })}
                          onChange={() => {
                            this.handleChange("cardfilterids", 5);
                          }}
                        />
                      </ListItemIcon>
                      <ListItemSecondaryAction style={{ right: 0 }}>
                        <span
                          className="dot"
                          style={{
                            backgroundColor: "#12CDD4",
                            height: 14,
                            width: 14,
                            borderRadius: 18,
                            display: "block",
                          }}
                        ></span>
                      </ListItemSecondaryAction>
                      {/* <p className="small-dark-secondary margin-left-8">
                    Checklist items
                  </p> */}
                    </ListItem>
                    <ListItem style={{ padding: "8px 0px" }}>
                      <ListItemIcon style={{ height: 24 }}>
                        <DynamicForm
                          fields={checkboxinputconverter({
                            value:
                              this.state.cardfilterids.indexOf(6) == -1
                                ? false
                                : true,
                            placeholder: "",
                            label: "Review open/ close",
                            labelclass: "small-dark-secondary width100",
                          })}
                          onChange={() => {
                            this.handleChange("cardfilterids", 6);
                          }}
                        />
                      </ListItemIcon>
                      <ListItemSecondaryAction style={{ right: 0 }}>
                        <span
                          className="dot"
                          style={{
                            backgroundColor: "#8FD14F",
                            height: 14,
                            width: 14,
                            borderRadius: 18,
                            display: "block",
                          }}
                        ></span>
                      </ListItemSecondaryAction>
                      {/* <p className="small-dark-secondary margin-left-8">
                    Review open/ close
                  </p> */}
                    </ListItem>
                    <ListItem style={{ padding: "8px 0px" }}>
                      <ListItemIcon style={{ height: 24 }}>
                        <DynamicForm
                          fields={checkboxinputconverter({
                            value:
                              this.state.cardfilterids.indexOf(7) == -1
                                ? false
                                : true,
                            placeholder: "",
                            label: "Payroll date",
                            labelclass: "small-dark-secondary width100",
                          })}
                          onChange={() => {
                            this.handleChange("cardfilterids", 7);
                          }}
                        />
                      </ListItemIcon>
                      <ListItemSecondaryAction style={{ right: 0 }}>
                        <span
                          className="dot"
                          style={{
                            backgroundColor: "#414BB2",
                            height: 14,
                            width: 14,
                            borderRadius: 18,
                            display: "block",
                          }}
                        ></span>
                      </ListItemSecondaryAction>
                      {/* <p className="small-dark-secondary margin-left-8">
                    Payroll date
                  </p> */}
                    </ListItem>
                  </List>
                </Grid>
                {/* <Divider
                  style={{
                    marginLeft: -16,
                    width: "calc(100% + 32px)",
                    marginTop: 8,
                    marginBottom: 8,
                  }}
                /> */}

                {/*
              <Divider orientation="vertical" flexItem  style={{
                    // marginLeft: -16,
                    // width: "calc(100% + 32px)",

                    width: "calc(100% - 32px)",
                    // marginTop: 8,
                    // marginBottom: 8,
                  }}/> */}
                <Grid
                  item
                  xs={12}
                  md={6}
                  sm={12}
                  style={{
                    borderLeft: "1px solid #A9A9A9",
                  }}
                >
                  <List style={{ paddingTop: 0 }}>
                    <ListSubheader
                      style={{
                        paddingLeft: 0,
                        fontWeight: "bold",
                        lineHeight: "32px",
                        color: " #545556",
                        marginTop: 0,
                      }}
                    >
                      View
                    </ListSubheader>
                    <ListItem style={{ padding: "8px 0px" }}>
                      <ListItemIcon style={{ height: 24 }}>
                        <DynamicForm
                          className="width100"
                          fields={radioinputconverter({
                            value: this.state.calendarview == "month",
                            label: "Month - Overview",
                            labelclass: "small-dark-secondary width100",
                            // disabled: this.state.check && this.state.check.editable ? false : true,
                          })}
                          onChange={() =>
                            this.handleChange("calendarview", "month")
                          }
                        />
                      </ListItemIcon>
                      {/* <p className="small-dark-secondary margin-left-8">
                    Month - Overview
                  </p> */}
                    </ListItem>
                    <ListItem style={{ padding: "8px 0px" }}>
                      <ListItemIcon style={{ height: 24 }}>
                        <DynamicForm
                          className="width100"
                          fields={radioinputconverter({
                            value: this.state.calendarview == "week",
                            label: " Week - Detailed",
                            labelclass: "small-dark-secondary width100",
                            // disabled: this.state.check && this.state.check.editable ? false : true,
                          })}
                          onChange={() =>
                            this.handleChange("calendarview", "week")
                          }
                        />
                      </ListItemIcon>
                      {/* <p className="small-dark-secondary margin-left-8">
                    Week - Detailed
                  </p> */}
                    </ListItem>
                    {/* <Divider
                  style={{
                    marginLeft: -16,
                    width: "calc(100% + 32px)",
                    marginTop: 8,
                    marginBottom: 8,
                  }}
                /> */}
                    <ListSubheader
                      style={{
                        paddingLeft: 0,
                        fontWeight: "bold",
                        lineHeight: "32px",
                        color: " #545556",
                        marginTop: 8,
                      }}
                    >
                      Data level
                    </ListSubheader>
                    {this.state.ismanager && (
                      <ListItem style={{ padding: "8px 0px" }}>
                        <ListItemIcon style={{ height: 24 }}>
                          <DynamicForm
                            className="width100"
                            fields={radioinputconverter({
                              value: this.state.empfilterid == 1,
                              label: "Direct reports",
                              labelclass: "small-dark-secondary width100",
                              disabled: this.state.isshiftplan,
                            })}
                            onChange={() => this.handleChange("empfilterid", 1)}
                          />
                        </ListItemIcon>
                        {/* <p className="small-dark-secondary margin-left-8">
                      Direct reports
                    </p> */}
                      </ListItem>
                    )}
                    {((this.props.AuthenticationAction &&
                      this.props.AuthenticationAction.login &&
                      this.props.AuthenticationAction.login.masterprofileid &&
                      this.props.AuthenticationAction.login.masterprofileid ==
                        9) ||
                      this.state.iscaldepartment) && (
                      <ListItem style={{ padding: "8px 0px" }}>
                        <ListItemIcon style={{ height: 24 }}>
                          <DynamicForm
                            className="width100"
                            fields={radioinputconverter({
                              value: this.state.empfilterid == 2,
                              label: " My department",
                              labelclass: "small-dark-secondary width100",
                              disabled: this.state.isshiftplan,
                            })}
                            onChange={() => this.handleChange("empfilterid", 2)}
                          />
                        </ListItemIcon>
                        {/* <p className="small-dark-secondary margin-left-8">
                    My department
                  </p> */}
                      </ListItem>
                    )}

                    {((this.props.AuthenticationAction &&
                      this.props.AuthenticationAction.login &&
                      this.props.AuthenticationAction.login.masterprofileid &&
                      this.props.AuthenticationAction.login.masterprofileid ==
                        9) ||
                      this.state.iscalorganization) && (
                      <ListItem style={{ padding: "8px 0px" }}>
                        <ListItemIcon style={{ height: 24 }}>
                          <DynamicForm
                            className="width100"
                            fields={radioinputconverter({
                              value: this.state.empfilterid == 3,
                              label: "Organization",
                              labelclass: "small-dark-secondary width100",
                              disabled: this.state.isshiftplan,
                            })}
                            onChange={() => this.handleChange("empfilterid", 3)}
                          />
                        </ListItemIcon>
                        {/* <p className="small-dark-secondary margin-left-8">
                        Organization
                      </p> */}
                      </ListItem>
                    )}
                  </List>
                </Grid>
                {/* <Divider
                  style={{
                    marginLeft: -16,
                    width: "calc(100% + 32px)",
                    marginTop: 8,
                    marginBottom: 8,
                  }}
                /> */}
                <Grid item xs={12} md={6} sm={12}>
                  <Grid container className="activityDivider">
                    <hr className="dashedDivider" />
                    <p className="dividerText">
                      <span className="LineDrawn">OR</span>
                    </p>
                    <hr className="dashedDivider" />
                  </Grid>
                  <div>
                    <DynamicForm
                      fields={checkboxinputconverter({
                        value: this.state.isshiftplan,
                        placeholder: "",
                        label: "My shift plan",
                        labelclass: "small-dark-secondary width100",
                      })}
                      onChange={() => {
                        this.setState(
                          {
                            isshiftplan: !this.state.isshiftplan,

                            // empfilterid: this.state.cardfilterids.length == 0 ? 4 : this.state.empfilterid,
                          },
                          () =>
                            this.handleChange(
                              "empfilterid",
                              this.state.isshiftplan
                                ? 4
                                : !this.state.ismanager
                                ? 2
                                : 1,
                              true,
                            ),
                        );
                      }}
                    />
                  </div>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={6}
                  sm={12}
                  style={{
                    borderLeft: "1px solid #A9A9A9",
                  }}
                >
                  <Grid container className="activityDivider" style={{}}>
                    <hr className="dashedDivider" />
                    <p className="dividerText">
                      <span className="LineDrawn">OR</span>
                    </p>
                    <hr className="dashedDivider" />
                  </Grid>
                  <div style={{ marginLeft: 8 }}>
                    <ListItem style={{ padding: "0px 0px" }}>
                      <ListItemIcon style={{ height: 24 }}>
                        <DynamicForm
                          className="width100"
                          fields={radioinputconverter({
                            value: this.state.empfilterid == 4,
                            label: "Self",
                            labelclass: "small-dark-secondary width100",
                            disabled: true,
                          })}
                          onChange={() => this.handleChange("empfilterid", 4)}
                        />
                      </ListItemIcon>
                      {/* <p className="small-dark-secondary margin-left-8">
                        Organization
                      </p> */}
                    </ListItem>
                  </div>
                </Grid>
              </Grid>

              {/* <Grid container className="activityDivider">
            <hr className="dashedDivider" />
            <p className="dividerText" ><span>OR</span></p>
            <hr className="dashedDivider" />
          </Grid> */}

              {/* <Divider
                  style={{
                    marginLeft: -16,
                    width: "calc(100% + 32px)",
                    marginTop: 8,
                    marginBottom: 8,
                  }}
                /> */}
              <Button
                variant="contained"
                className="btn btn-primary-sm-blue margin-top-16 width100"
                startIcon={<img src={filterIcon}></img>}
                onClick={
                  this.state.isshiftplan
                    ? this.GetEmpDetails
                    : this.state.calendarview == "week"
                    ? this.getWeekView
                    : this.getMonthView
                }
                // onClick={() => {
                //   this.getWeekView();
                //   this.getMonthView();
                // }}
              >
                Apply filter
              </Button>
            </Paper>
          </Popover>
        </div>
        {this.state.loading == true ? (
          <LoaderComponent />
        ) : (
          <Calendar
            localizer={localizer}
            events={
              this.state.templistdata
                ? this.state.tempList
                : this.state.view == "week"
                ? this.state.weekviewdata
                : this.state.monthviewdata
            }
            view={this.state.view}
            isshiftplan={this.state.isshiftplan}
            views={["month", "week"]}
            defaultDate={this.state.defaultDate}
            // defaultDate={new Date(defaultDate)}
            date={this.state.defaultDate}
            // onSelectEvent={this.openeventdetails}
            // date={new Date(defaultDate)}
            step={30}
            min={this.state.maxDate}
            max={this.state.minDate}
            // min={new Date(fromdate)}
            // max={new Date(todate)}
            // min={new Date()}
            // max={new Date()}
            // popup={true}
            // startAccessor={(event) => moment(event.clientData[0].date)}
            // endAccessor={(event) => moment(event.clientData[0].date)}
            startAccessor="start"
            // onSelectEvent={this.GetParticularEvent.bind(this)}
            endAccessor="end"
            eventPropGetter={this.eventStyleGetter.bind(this)}
            components={{
              toolbar:
                moment(fromdate, "YYYY-MM-DD").format("MM") !=
                moment(todate, "YYYY-MM-DD").format("MM")
                  ? ToolBars({
                      min: new Date(fromdate),
                      max: new Date(todate),
                    })
                  : CustomToolbar,
              // toolbar: CustomToolbar,
              event: CustomEventContainer({
                openeventdetails: this.openeventdetails,
                openshiftdetails: this.openshiftdetails,
                closedetails: this.closedetails,
                view: this.state.view,
                isshiftplan: this.state.isshiftplan,
                eventdetails: this.state.eventdetails,
                shiftdetails: this.state.shiftdetails,
                shiftdetaildata: this.state.shiftdetaildata,
                shiftdetaildata1: this.state.shiftdetaildata1,
                eventdetails_anchorEl: this.state.eventdetails_anchorEl,
                shiftdetails_anchorEl: this.state.shiftdetails_anchorEl,
                selectedeventtype: this.state.selectedeventtype,
                defaultEmp: this.state.defaultEmp,
                loadMonthEventItems: this.loadMonthEventItems,
                selectedDate: this.state.selectedDate,
                openDrawer: this.openDrawer,
                openDrawer1: this.openDrawer1,
                OptionalDrawerOpen: this.state.OptionalDrawerOpen,
                MandatoryDrawerOpen: this.state.MandatoryDrawerOpen,
                closeDrawer: this.closeDrawer,
                closeDrawer1: this.closeDrawer1,
                weekviewdata: this.state.weekviewdata,
                popupdata: this.state.popupdata,
                getData: this.getData,
                downloadhtml: this.downloadhtml,

                data1: this.state.data1,
                data2: this.state.data2,
                paysliploading: this.state.paysliploading,
                detailsloading: this.state.detailsloading,
                defaultDate: this.state.defaultDate,
                todaysdate: this.state.todaysdate,
                tempList: this.state.tempList,
                templistdata: this.state.templistdata,
              }),
            }}
            onNavigate={(
              date,
              view = this.state.isshiftplan ? "isshiftplan" : view,
              action,
            ) =>
              this.Navigate(
                date,
                (view = this.state.isshiftplan ? "isshiftplan" : view),
                action,
              )
            }
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  AuthenticationAction: state.AuthenticationAction,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withSnackbar(AppCalendar));
